<template>
  <div>
    <div v-if="currentStep === 1">
      <div class="home">
        <div class="container form-container1 text-center fadeInDown">
          <div class="row">
            <div class="col-xl-12 text-center">
              <div class="card checkinCard">
                <div class="card-body text-center">
                  <h4 class="font-weight-bold indigo-text">
                    Welcome to <br />
                    {{ locationName }} <br />
                  </h4>
                  <h4 class="font-weight-bold indigo-text">
                    Check-In Form<br />
                  </h4>
                  <p>Click on the button below to start</p>
                  <!-- <h4 class="font-weight-bold indigo-text">Checkin</h4> -->
                  <a
                    type="button"
                    :class="myHoverfunc()"
                    @click="checkinTypeClick('checkin', 2)"
                    >Checkin</a
                  >
                </div>
              </div>
            </div>

            <!-- <div class="col-xl-6 text-center">
              <div class="card checkinCard">
                <div class="card-body text-center">
                  <h4 class="font-weight-bold indigo-text">
                    Veins Express Checkin
                  </h4>
                  <p>Have a Veins ID?</p>
                  <a
                    type="button"
                    :class="myHoverfunc1()"
                    @click="checkinTypeClick('expresscheckin', 2)"
                    >Checkin</a
                  >
                </div>
              </div>
            </div> -->
          </div>

          <div class="row">
            <div class="card col" id="backbtncard">
              <!-- <a>
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                  @click="nextStageClick(0)"
                />
              </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Visit Type -->
    <div v-if="currentStep === 2">
      <section id="step-1" class="section active m-b-40">
        <div class="container form-container text-center slide">
          <div class="container text-center" id="middleFix">
            <h2 class="font-weight-bold text-uppercase">Select Visit Type</h2>
            <!--Checkbox-->
            <div class="form-group">
              <div
                class="form-checkbox"
                v-for="(type, ndx01) in types"
                :key="type.visitTypeId"
                @click="visitTypeClick(ndx01)"
              >
                <input
                  v-if="currentSelectedTypeId == type.visitTypeId"
                  required
                  class="radio"
                  type="radio"
                  name=""
                  value=""
                  checked="checked"
                />
                <label class="checklabel" for="">{{ type.name }}</label>
              </div>
            </div>
            <!--Checkbox-->
          </div>

          <div class="row">
            <div class="card col" id="backbtncard" @click="nextStageClick(1)">
              <a href="#">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard" @click="nextStageClick(3)">
              <a href="#">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- END visit Type -->

    <!-- Visit Reason START -->
    <div v-if="currentStep === 3">
      <section id="step-1" class="section active m-b-40">
        <div class="container form-container text-center slide">
          <div class="container text-center" id="middleFix">
            <h2 class="font-weight-bold text-uppercase">Select Visit Reason</h2>
            <!--Checkbox-->
            <div
              class="form-group"
              v-for="(reason, ndx02) in visitTypeReasons"
              :key="ndx02"
              @click="reasonClick(ndx02)"
            >
              <div class="form-checkbox">
                <input
                  v-if="currentSelectedReasonId == reason.visitDetailId"
                  required
                  class="radio"
                  type="radio"
                  name=""
                  value=""
                  checked="checked"
                />
                <!-- <input
                required
                class="radio"
                type="radio"
                name=""
                id=""
                value=""
              /> -->
                <label style="margin-bottom: -1.5rem" class="checklabel">{{
                  reason.reasonName
                }}</label>
              </div>
            </div>
            <!--Checkbox-->
          </div>

          <div class="row">
            <div class="card col" id="backbtncard" @click="nextStageClick(2)">
              <a href="#">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard" @click="nextStageClick(4)">
              <a href="#">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Visit Reason END -->

    <!-- Basic Details BEGIN -->
    <div v-if="currentStep === 4">
      <section id="step-3" class="section active m-b-40">
        <div class="container form-container">
          <div v-if="alertShown == 1" class="alert alert-danger text-center">
            Profile Not Found!! Enter Your Information
          </div>
          <h3 class="font-weight-bold h3Spacing text-center">Basic Details</h3>
          <form class="floating-labels" @submit.prevent="onSubmit(event)">
            <!-- first row -->
            <div class="row">
              <div class="col-lg-12">
                <div
                  class="form-group"
                  v-bind:class="[
                    basicDetails.firstName.length != 0 ? 'focused' : ' ',
                  ]"
                >
                  <input
                    type="text"
                    class="form-control required"
                    id="firstName"
                    aria-labelledby="firstName_label"
                    maxlength="60"
                    placeholder=""
                    required
                    v-model="basicDetails.firstName"
                  /><span class="bar"></span>
                  <label
                    for="firstName"
                    id="firstName_label"
                    style="margin-left: -50%"
                    >First Name</label
                  >
                </div>
                <!-- first name -->
              </div>
              <div class="col-lg-12">
                <!-- last name -->
                <div
                  class="form-group"
                  v-bind:class="[
                    basicDetails.lastName.length != 0 ? 'focused' : '',
                  ]"
                >
                  <input
                    type="text"
                    class="form-control required"
                    id="lastName"
                    aria-labelledby="lastName_label"
                    maxlength="60"
                    placeholder=""
                    v-model="basicDetails.lastName"
                  /><span class="bar"></span>
                  <label
                    for="lastName"
                    id="lastName_label"
                    style="margin-left: -50%"
                    >Last Name</label
                  >
                </div>
                <!-- last name -->
              </div>
            </div>
            <!-- first row -->

            <!-- second row -->
            <div class="row">
              <!-- <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <label
                    for=""
                    style="
                      margin-top: -22px;
                      margin-left: -50%;
                      font-weight: bold;
                    "
                    >Date of Birth</label
                  >
                  <input
                    type="date"
                    class="form-control required"
                    id="dob"
                    v-model="basicDetails.dob"
                    placeholder=""
                  /><span class="bar"></span>
                </div>
              </div> -->

              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <label
                    for=""
                    style="
                      margin-top: -22px;
                      margin-left: -50%;
                      font-weight: bold;
                    "
                    >Date of Birth</label
                  >
                  <div
                    class="form-group row row-lg-12"
                    style=" margin-left:-0.2%
                  width:100%; border-bottom: 2px solid #ff0000;margin-top:2px !important; "
                  >
                    <form @submit.prevent="onSubmit(event)">
                      <input
                        type="number"
                        class="month"
                        id="dobm"
                        v-mask="'##'"
                        @keypress="isMonth($event, month)"
                        maxlength="2"
                        min="1"
                        max="12"
                        v-model="month"
                        placeholder="MM"
                      />
                      <span class="datedivider">/</span>
                      <input
                        type="number"
                        class="day"
                        id="dobd"
                        min="1"
                        max="31"
                        v-mask="'##'"
                        @keypress="isDay($event, day)"
                        v-model="day"
                        placeholder="DD"
                      />
                      <span class="datedivider">/</span>
                      <input
                        type="number"
                        class="year"
                        id="doby"
                        v-mask="'####'"
                        @keypress="isYear($event, year)"
                        v-model="year"
                        placeholder="YYYY"
                      />
                    </form>
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group m-b-40">
                  <input
                    class="input1"
                    type="radio"
                    value="Male"
                    name="radio33"
                    v-model="basicDetails.gender"
                    id=""
                  />
                  <label
                    style="margin-left: -100px; margin-top: 8px"
                    for="radio33"
                    class="btn btn-outline-info label1"
                    @click="setBasicRadio('Male')"
                  >
                    Male
                  </label>
                  <input
                    class="input1"
                    type="radio"
                    value="Female"
                    name="radio33"
                    v-model="basicDetails.gender"
                    id=""
                  />
                  <label
                    style="margin-left: -42px; margin-top: 8px"
                    for="radio33"
                    class="btn btn-outline-info label1"
                    @click="setBasicRadio('Female')"
                  >
                    Female
                  </label>
                  <input
                    class="input1"
                    type="radio"
                    value="Other"
                    name="radio33"
                    v-model="basicDetails.gender"
                    id=""
                  />
                  <label
                    style="margin-left: 33px; margin-top: 8px"
                    for="radio33"
                    class="btn btn-outline-info label1"
                    @click="setBasicRadio('Other')"
                  >
                    Other
                  </label>
                  <label
                    for=""
                    style="
                      margin-left: -56%;
                      margin-top: -18px;
                      font-weight: bold;
                    "
                    >Gender</label
                  >
                </div>
              </div>
            </div>
            <!-- second row -->

            <!-- fourth row -->
            <div v-for="(val, ndx033) in choseBasic" :key="ndx033">
              <div class="row" v-if="val.question == 'SSN'">
                <div
                  class="form-group m-b-40 col-12"
                  style="margin-top: 20px"
                  v-bind:class="[basicDetails.ssn.length != 0 ? 'focused' : '']"
                >
                  <input
                    v-mask="'###-##-####'"
                    type="tel"
                    class="form-control"
                    id="ssn"
                    aria-labelledby="ssn_label"
                    placeholder=""
                    v-model="basicDetails.ssn"
                  /><span class="bar"></span>
                  <label for="ssn" id="ssn_label" style="margin-left: -50%"
                    >Social Security Number</label
                  >
                </div>
              </div>
            </div>
            <!-- fourth row -->
          </form>

          <div class="row">
            <div class="card col" id="backbtncard" @click="nextStageClick(3)">
              <a href="#">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard" @click="nextStageClick(5)">
              <a href="#">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Basic Details END -->

    <!-- Contact Information BEGIN -->
    <div v-if="currentStep === 6">
      <section id="step-4" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">
            Contact Information
          </h3>
          <form class="floating-labels" @submit.prevent="onSubmit(event)">
            <!-- third row -->
            <div class="row">
              <div
                v-for="(val, ndx044) in choseBasic"
                :key="ndx044"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Phone'"
                  class="form-group m-b-40"
                  v-bind:class="[
                    basicDetails.phone.length != 0 ? 'focused' : '',
                  ]"
                >
                  <input
                    v-mask="'###-###-####'"
                    type="tel"
                    class="form-control required"
                    id="phone"
                    aria-labelledby="phone_label"
                    placeholder=""
                    v-model="basicDetails.phone"
                  /><span class="bar"></span>
                  <label for="phone" id="phone_label" style="margin-left: -50%"
                    >Phone Number</label
                  >
                </div>
              </div>
              <div
                v-for="(val, ndx043) in choseBasic"
                :key="ndx043"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Email'"
                  class="form-group m-b-40"
                  v-bind:class="[
                    basicDetails.email.length != 0 ? 'focused' : '',
                  ]"
                >
                  <input
                    type="email"
                    class="form-control required"
                    id="email"
                    aria-labelledby="email_label"
                    placeholder=""
                    maxlength="50"
                    v-model="basicDetails.email"
                  /><span class="bar"></span>
                  <label for="email" id="email_label" style="margin-left: -50%"
                    >Email</label
                  >
                </div>
              </div>
            </div>
            <!-- third row -->
          </form>

          <div class="row">
            <div class="card col" id="backbtncard" @click="nextStageClick(4)">
              <a href="#">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard" @click="nextStageClick(6)">
              <a href="#">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Contact Information END -->

    <!-- Address BEGIN -->
    <div v-if="currentStep === 7">
      <section id="step-5" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">Address</h3>
          <form class="floating-labels" @submit.prevent="onSubmit(event)">
            <!-- fifth row -->
            <div class="row">
              <div
                v-for="(val, ndx030) in choseBasic"
                :key="ndx030"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Street'"
                  class="form-group m-b-40"
                  v-bind:class="[
                    basicDetails.address.length != 0 ? 'focused' : '',
                  ]"
                >
                  <input
                    maxlength="100"
                    type="text"
                    class="form-control required"
                    id="street"
                    aria-labelledby="street_label"
                    placeholder=""
                    v-model="basicDetails.address"
                  /><span class="bar"></span>
                  <label
                    for="street"
                    id="street_label"
                    style="margin-left: -50%"
                    >Street</label
                  >
                </div>
              </div>
              <div
                v-for="(val, ndx031) in choseBasic"
                :key="ndx031"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'City'"
                  class="form-group m-b-40"
                  v-bind:class="[
                    basicDetails.city.length != 0 ? 'focused' : '',
                  ]"
                >
                  <input
                    type="text"
                    maxlength="30"
                    class="form-control required"
                    id="city"
                    aria-labelledby="city_label"
                    placeholder=""
                    v-model="basicDetails.city"
                  /><span class="bar"></span>
                  <label for="city" id="city_label" style="margin-left: -50%"
                    >City</label
                  >
                </div>
              </div>
              <div
                v-for="(val, ndx032) in choseBasic"
                :key="ndx032"
                class="col-lg-12"
              >
                <div class="form-group m-b-40" v-if="val.question == 'State'">
                  <select
                    class="form-control custom-select required"
                    tabindex="1"
                    v-model="basicDetails.state"
                  >
                    <option value="">Select One</option>
                    <option value="FL">FL</option>
                    <option value="AL">AL</option>
                    <option value="AK">AK</option>
                    <option value="AZ">AZ</option>
                    <option value="AR">AR</option>
                    <option value="CA">CA</option>
                    <option value="CO">CO</option>
                    <option value="CT">CT</option>
                    <option value="DE">DE</option>
                    <option value="GA">GA</option>
                    <option value="HI">HI</option>
                    <option value="ID">ID</option>
                    <option value="IL">IL</option>
                    <option value="IN">IN</option>
                    <option value="IA">IA</option>
                    <option value="KS">KS</option>
                    <option value="KY">KY</option>
                    <option value="ME">ME</option>
                    <option value="MD">MD</option>
                    <option value="MA">MA</option>
                    <option value="MI">MI</option>
                    <option value="MN">MN</option>
                    <option value="MS">MS</option>
                    <option value="MO">MO</option>
                    <option value="MT">MT</option>
                    <option value="NE">NE</option>
                    <option value="NV">NV</option>
                    <option value="NH">NH</option>
                    <option value="NJ">NJ</option>
                    <option value="NM">NM</option>
                    <option value="NY">NY</option>
                    <option value="NC">NC</option>
                    <option value="ND">ND</option>
                    <option value="OH">OH</option>
                    <option value="OK">OK</option>
                    <option value="OR">OR</option>
                    <option value="PA">PA</option>
                    <option value="RI">RI</option>
                    <option value="SC">SC</option>
                    <option value="SD">SD</option>
                    <option value="TN">TN</option>
                    <option value="TX">TX</option>
                    <option value="UT">UT</option>
                    <option value="VT">VT</option>
                    <option value="VA">VA</option>
                    <option value="WA">WA</option>
                    <option value="WV">WV</option>
                    <option value="WI">WI</option>
                    <option value="WY">WY</option>
                  </select>
                  <label
                    for=""
                    style="
                      margin-left: -50%;
                      margin-top: -18px;
                      font-weight: bold;
                    "
                    >State</label
                  >
                </div>
              </div>

              <div
                v-for="(val, ndx034) in choseBasic"
                :key="ndx034"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Zip'"
                  class="form-group m-b-40"
                  v-bind:class="[basicDetails.zip.length != 0 ? 'focused' : '']"
                >
                  <input
                    v-mask="'#####'"
                    type="number"
                    class="form-control required"
                    id="zip"
                    aria-labelledby="zip_label"
                    placeholder=""
                    v-model="basicDetails.zip"
                  /><span class="bar"></span>
                  <label for="zip" id="zip_label" style="margin-left: -50%"
                    >Zip</label
                  >
                </div>
              </div>
            </div>
            <!-- fifth row -->
          </form>

          <div class="row">
            <div class="card col" id="backbtncard" @click="backStageClick(4)">
              <a href="#">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard" @click="nextStageClick(7)">
              <a href="#">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Address END -->

    <!-- Insurance BEGIN -->
    <div v-if="currentStep === 8">
      <section id="step-6" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">Insurance</h3>
          <form class="floating-labels" @submit.prevent="onSubmit(event)">
            <!-- fifth row -->
            <div class="row">
              <div
                v-for="(val, ndx121) in choseBasic"
                :key="ndx121"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Primary Insurance Name'"
                  class="form-group m-b-40"
                  v-bind:class="[
                    Insurance.primaryInsuranceName.length != 0 ? 'focused' : '',
                  ]"
                >
                  <input
                    maxlength="100"
                    type="text"
                    class="form-control required"
                    id="PrimaryInsuranceName"
                    aria-labelledby="PrimaryInsuranceName_label"
                    placeholder=""
                    v-model="Insurance.primaryInsuranceName"
                  /><span class="bar"></span>
                  <label
                    for="PrimaryInsuranceName"
                    id="PrimaryInsuranceName_label"
                    style="margin-left: -50%"
                    >Primary Insurance Name</label
                  >
                </div>
              </div>
              <div
                v-for="(val, ndx122) in choseBasic"
                :key="ndx122"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Primary Insurance Number'"
                  class="form-group m-b-40"
                  v-bind:class="[
                    Insurance.primaryInsuranceNumber.length != 0
                      ? 'focused'
                      : '',
                  ]"
                >
                  <input
                    type="text"
                    maxlength="30"
                    class="form-control required"
                    id="PrimaryInsuranceNumber"
                    aria-labelledby="PrimaryInsuranceNumber_label"
                    placeholder=""
                    v-model="Insurance.primaryInsuranceNumber"
                  /><span class="bar"></span>
                  <label
                    for="PrimaryInsuranceNumber"
                    id="PrimaryInsuranceNumber_label"
                    style="margin-left: -50%"
                    >Primary Insurance Number</label
                  >
                </div>
              </div>
              <div
                v-for="(val, ndx123) in choseBasic"
                :key="ndx123"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Primary Insurance Group Name'"
                  class="form-group m-b-40"
                  v-bind:class="[
                    Insurance.primaryInsuranceGroup.length != 0
                      ? 'focused'
                      : '',
                  ]"
                >
                  <input
                    type="text"
                    maxlength="30"
                    class="form-control required"
                    id="PrimaryInsuranceGroup"
                    aria-labelledby="PrimaryInsuranceGroup_label"
                    placeholder=""
                    v-model="Insurance.primaryInsuranceGroup"
                  /><span class="bar"></span>
                  <label
                    for="PrimaryInsuranceGroup"
                    id="PrimaryInsuranceGroup_label"
                    style="margin-left: -50%"
                    >Primary Insurance Group Name</label
                  >
                </div>
              </div>

              <!-- <div
                v-for="(val, ndx22) in choseBasic"
                :key="ndx22"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Primary Insurance Image Upload'"
                  class="form-group m-b-40 col-md-6 mb-3"
                >
                  <p class="boldText">Primary Image Upload</p>
                  <input
                    type="file"
                    id="fileUpload"
                    accept="image/*"
                    @change="getImage"
                  />
                  <img
                    :src="SingleImage.Image"
                    alt=""
                    style="
                      border-radius: 50%;
                      max-width: 100px;
                      margin-top: 10px;
                      margin-bottom: 10px;
                    "
                  />
                </div>
              </div> -->

              <div
                v-for="(val, ndx131) in choseBasic"
                :key="ndx131"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Secondary Insurance Name'"
                  class="form-group m-b-40"
                  v-bind:class="[
                    Insurance.secondaryInsuranceName.length != 0
                      ? 'focused'
                      : '',
                  ]"
                >
                  <input
                    maxlength="100"
                    type="text"
                    class="form-control required"
                    id="SecondaryInsuranceName"
                    aria-labelledby="SecondaryInsuranceName_label"
                    placeholder=""
                    v-model="Insurance.secondaryInsuranceName"
                  /><span class="bar"></span>
                  <label
                    for="SecondaryInsuranceName"
                    id="SecondaryInsuranceName_label"
                    style="margin-left: -50%"
                    >Secondary Insurance Name</label
                  >
                </div>
              </div>
              <div
                v-for="(val, ndx132) in choseBasic"
                :key="ndx132"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Secondary Insurance Number'"
                  class="form-group m-b-40"
                  v-bind:class="[
                    Insurance.secondaryInsuranceNumber.length != 0
                      ? 'focused'
                      : '',
                  ]"
                >
                  <input
                    type="text"
                    maxlength="30"
                    class="form-control required"
                    id="SecondaryInsuranceNumber"
                    aria-labelledby="SecondaryInsuranceNumber_label"
                    placeholder=""
                    v-model="Insurance.secondaryInsuranceNumber"
                  /><span class="bar"></span>
                  <label
                    for="SecondaryInsuranceNumber"
                    id="SecondaryInsuranceNumber_label"
                    style="margin-left: -50%"
                    >Secondary Insurance Number</label
                  >
                </div>
              </div>
              <div
                v-for="(val, ndx133) in choseBasic"
                :key="ndx133"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Secondary Insurance Group Name'"
                  class="form-group m-b-40"
                  v-bind:class="[
                    Insurance.secondaryInsuranceGroup.length != 0
                      ? 'focused'
                      : '',
                  ]"
                >
                  <input
                    type="text"
                    maxlength="30"
                    class="form-control required"
                    id="SecondaryInsuranceGroup"
                    aria-labelledby="SecondaryInsuranceGroup_label"
                    placeholder=""
                    v-model="Insurance.secondaryInsuranceGroup"
                  /><span class="bar"></span>
                  <label
                    for="SecondaryInsuranceGroup"
                    id="SecondaryInsuranceGroup_label"
                    style="margin-left: -50%"
                    >Secondary Insurance Group Name</label
                  >
                </div>
              </div>

              <!-- <div
                v-for="(val, ndx24) in choseBasic"
                :key="ndx24"
                class="col-lg-12"
              >
                <div
                  v-if="val.question == 'Secondary Insurance Image upload'"
                  class="form-group m-b-40 col-md-6 mb-3"
                >
                  <p class="boldText">Secondary Image Upload</p>
                  <input
                    type="file"
                    id="fileUpload1"
                    accept="image/*"
                    @change="getImage1"
                  />
                  <img
                    :src="SingleImage1.Image1"
                    alt=""
                    style="
                      border-radius: 50%;
                      max-width: 100px;
                      margin-top: 20px;
                    "
                  />
                </div>
              </div> -->
            </div>
            <!-- fifth row -->
          </form>

          <div class="row">
            <div class="card col" id="backbtncard" @click="backStageClick(5)">
              <a href="#">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard" @click="nextStageClick(8)">
              <a href="#">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Insurance END -->

    <!-- Custom Demo START -->
    <div v-if="currentStep === 9">
      <!-- *66* 
    1: Textbox
    2: Checkbox
    3: Rating
    4: Radio Button
    5: Email
    6: Phone Number
    7: Date -->
      <section id="" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">
            Other Demographic Information
          </h3>
          <form
            class="floating-labels"
            v-if="reasonDemos.length > 0"
            @submit.prevent="onSubmit(event)"
          >
            <div v-for="(res, ndx03) in reasonDemos" :key="ndx03">
              <!-- **** TEXT **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 1">
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p
                      v-if="res.demo.isRequired == true"
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                      <i
                        class="fa fa-asterisk"
                        id="asterik"
                        aria-hidden="true"
                      ></i>
                    </p>
                    <p
                      v-else
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                    </p>
                  </div>
                  <div class="form-group" style="margin-top: -18px">
                    <input
                      type="text"
                      class="form-control required"
                      id=""
                      placeholder=""
                      maxlength="200"
                      v-model="res.demo.answer"
                    />
                  </div>
                </fieldset>
              </div>

              <!-- **** CHECK BOX **** -->
              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 2"
              >
                <div class="form-group">
                  <p
                    v-if="res.demo.isRequired == true"
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                    <i
                      class="fa fa-asterisk"
                      id="asterik"
                      aria-hidden="true"
                    ></i>
                  </p>
                  <p
                    v-else
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                  </p>
                  <div class="input-group">
                    <div class="floating-labels">
                      <div class="row" style="text-align: left">
                        <div
                          class="form-group col-12 m-b-10"
                          v-for="(op, ndx04) in res.demo.demoOptions"
                          :key="ndx04"
                        >
                          <div>
                            <button
                              v-if="op.questOptionId == res.demo.answer"
                              style="background-color: #FF7062"
                              for="checkbox1"
                              @click="
                                demoOptionSelected(ndx03, ndx04, 'check-box')
                              "
                              :class="
                                demoCheckBoxSelected.includes(op.questOptionId)
                                  ? 'set-button'
                                  : 'set-button-warning'
                              "
                            >
                              {{ op.questOption }}
                            </button>
                            <button
                              v-else
                              style=""
                              for="checkbox1"
                              @click="
                                demoOptionSelected(ndx03, ndx04, 'check-box')
                              "
                              :class="
                                demoCheckBoxSelected.includes(op.questOptionId)
                                  ? 'set-button'
                                  : 'set-button-warning'
                              "
                            >
                              {{ op.questOption }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** RATING **** -->

              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 3"
              >
                <div class="form-group">
                  <p
                    v-if="res.demo.isRequired == true"
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                    <i
                      class="fa fa-asterisk"
                      id="asterik"
                      aria-hidden="true"
                    ></i>
                  </p>
                  <p
                    v-else
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                  </p>
                  <div class="input-group">
                    <div class="floating-labels">
                      <div class="row" style="text-align: left">
                        <div
                          class="form-group col-12 m-b-10"
                          v-for="(op, ndx04) in res.demo.demoOptions"
                          :key="ndx04"
                        >
                          <button
                            v-if="op.questOptionId == res.demo.answer"
                            style="background-color: #FF7062"
                            for="radio2"
                            class=""
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="op.questOption"
                            @click="demoOptionSelected(ndx03, ndx04)"
                            :class="
                              op.questOptionId == res.demo.answer
                                ? 'set-button'
                                : 'set-button-warning'
                            "
                          >
                            {{ op.questOption }}
                          </button>
                          <button
                            v-else
                            style=""
                            for="radio2"
                            class="set-button-warning"
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="op.questOption"
                            @click="demoOptionSelected(ndx03, ndx04)"
                          >
                            {{ op.questOption }}
                          </button>
                          <!-- <label
                            for="radio2"
                            class="btn btn-outline-info label1"
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="op.questOption"
                            @click="demoOptionSelected(ndx03, ndx04)"
                            :class="
                              op.questOptionId == res.demo.answer
                                ? 'btn btn-info label1'
                                : 'btn btn-outline-info label1'
                            "
                            >O{{ ndx04 + 1 }}</label
                          > -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** RADIO BUTTON **** -->

              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 4"
              >
                <div
                  class="form-group"
                  style="margin-bottom: 2px !important"
                  onsubmit="return false"
                >
                  <p
                    v-if="res.demo.isRequired == true"
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                    <i
                      class="fa fa-asterisk"
                      id="asterik"
                      aria-hidden="true"
                    ></i>
                  </p>
                  <p
                    v-else
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                  </p>
                </div>
                <div class="input-group">
                  <div class="floating-labels">
                    <div class="row" style="text-align: left">
                      <div
                        class="form-group col-12 m-b-10"
                        v-for="(op, ndx04) in res.demo.demoOptions"
                        :key="ndx04"
                      >
                        <button
                          v-if="op.questOptionId == res.demo.answer"
                          style="background-color: #FF7062"
                          for="radio11"
                          class=""
                          @click="demoOptionSelected(ndx03, ndx04)"
                          :class="
                            op.questOptionId == res.demo.answer
                              ? 'set-button'
                              : 'set-button-warning'
                          "
                        >
                          {{ op.questOption }}
                        </button>
                        <button
                          v-else
                          style=""
                          for="radio11"
                          class="set-button-warning"
                          @click="demoOptionSelected(ndx03, ndx04)"
                        >
                          {{ op.questOption }}
                        </button>
                        <!-- <label
                        for="radio11"
                        class="btn btn-outline-info label1"
                        @click="demoOptionSelected(ndx03, ndx04)"
                        :class="
                          op.questOptionId == res.demo.answer
                            ? 'btn btn-info label1'
                            : 'btn btn-outline-info label1'
                        "
                        >{{ op.questOption }}</label
                      > -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** EMAIL **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 5">
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p
                      v-if="res.demo.isRequired == true"
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                      <i
                        class="fa fa-asterisk"
                        id="asterik"
                        aria-hidden="true"
                      ></i>
                    </p>
                    <p
                      v-else
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                    </p>
                  </div>
                  <div class="form-group" style="margin-top: -18px">
                    <input
                      type="text"
                      class="form-control required"
                      id=""
                      maxlength="50"
                      placeholder=""
                      v-model="res.demo.answer"
                    />
                  </div>
                </fieldset>
              </div>

              <!-- **** PHONE **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 6">
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p
                      v-if="res.demo.isRequired == true"
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                      <i
                        class="fa fa-asterisk"
                        id="asterik"
                        aria-hidden="true"
                      ></i>
                    </p>
                    <p
                      v-else
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                    </p>
                  </div>
                  <div class="form-group" style="margin-top: -18px">
                    <input
                      v-mask="'###-###-####'"
                      type="tel"
                      class="form-control required"
                      id=""
                      placeholder=""
                      v-model="res.demo.answer"
                    />
                  </div>
                </fieldset>
              </div>

              <!-- **** DATE **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 7">
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p
                      v-if="res.demo.isRequired == true"
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                      <i
                        class="fa fa-asterisk"
                        id="asterik"
                        aria-hidden="true"
                      ></i>
                    </p>
                    <p
                      v-else
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                    </p>
                  </div>
                  <div class="form-group" style="margin-top: -18px">
                    <input
                      type="date"
                      class="form-control"
                      id=""
                      v-model="res.demo.answer"
                    /><span class="bar"></span>
                  </div>
                </fieldset>
              </div>
            </div>
          </form>

          <div class="row">
            <div class="card col" id="backbtncard" @click="backStageClick(6)">
              <a href="#">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard" @click="nextStageClick(9)">
              <a href="#">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Custom Demo START -->

    <!-- Questionnaire START -->
    <div v-if="currentStep === 10">
      <section id="step-7" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">Questionnaire</h3>
          <!-- ------------------------------------- -->
          <form
            class="floating-labels"
            v-if="reasonQuests.length > 0"
            onsubmit="return false"
          >
            <div v-for="(res, ndx03) in reasonQuests" :key="ndx03">
              <!-- **** TEXT **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 1">
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p
                      v-if="res.demo.isRequired == true"
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                      <i
                        class="fa fa-asterisk"
                        id="asterik"
                        aria-hidden="true"
                      ></i>
                    </p>
                    <p
                      v-else
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                    </p>
                  </div>
                  <div class="form-group" style="margin-top: -18px">
                    <input
                      type="text"
                      class="form-control required"
                      id=""
                      maxlength="200"
                      placeholder=""
                      v-model="res.demo.answer"
                    />
                  </div>
                </fieldset>
              </div>

              <!-- **** CHECK BOX **** -->
              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 2"
              >
                <div class="form-group">
                  <p
                    v-if="res.demo.isRequired == true"
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                    <i
                      class="fa fa-asterisk"
                      id="asterik"
                      aria-hidden="true"
                    ></i>
                  </p>
                  <p
                    v-else
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                  </p>
                  <div class="input-group">
                    <div class="floating-labels">
                      <div class="row" style="text-align: left">
                        <div
                          class="form-group col-12 m-b-10"
                          v-for="(op, ndx04) in res.demo.demoOptions"
                          :key="ndx04"
                        >
                          <div>
                            <button
                              v-if="op.questOptionId == res.demo.answer"
                              style="background-color: #FF7062"
                              for="checkbox"
                              @click="
                                questOptionSelected(ndx03, ndx04, 'check-box')
                              "
                              :class="
                                questCheckBoxSelected.includes(op.questOptionId)
                                  ? 'set-button'
                                  : 'set-button-warning'
                              "
                            >
                              {{ op.questOption }}
                            </button>
                            <button
                              v-else
                              style=""
                              for="checkbox"
                              @click="
                                questOptionSelected(ndx03, ndx04, 'check-box')
                              "
                              :class="
                                questCheckBoxSelected.includes(op.questOptionId)
                                  ? 'set-button'
                                  : 'set-button-warning'
                              "
                            >
                              {{ op.questOption }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div
                          class="form-group col-5 m-r-40"
                          v-for="(op, ndx04) in res.demo.demoOptions"
                          :key="ndx04"
                        >
                          <div style="margin-right: 100px">
                            <input
                              class="input1"
                              type="checkbox"
                              value="3"
                              name="checkbox"
                              id=""
                            />
                            <button
                              v-if="op.questOptionId == res.demo.answer"
                              style="
                                background-color: #00bfff; 
                                margin-left: -17px;
                              "
                              for="checkbox1"
                              @click="
                                questOptionSelected(ndx03, ndx04, 'check-box')
                              "
                              :class="
                                questCheckBoxSelected.includes(op.questOptionId)
                                  ? 'btn btn-info label1'
                                  : 'btn btn-outline-info label1'
                              "
                            >
                              {{ op.questOption }}
                            </button>
                            <button
                              v-else
                              style=" margin-left: -17px"
                              for="checkbox1"
                              @click="
                                questOptionSelected(ndx03, ndx04, 'check-box')
                              "
                              :class="
                                questCheckBoxSelected.includes(op.questOptionId)
                                  ? 'btn btn-info label1'
                                  : 'btn btn-outline-info label1'
                              "
                            >
                              {{ op.questOption }}
                            </button>
                          </div>
                        </div> -->
              <!-- </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- op.questOptionId == res.demo.answer -->

              <!-- **** RATING **** -->

              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 3"
              >
                <div class="form-group">
                  <p
                    v-if="res.demo.isRequired == true"
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                    <i
                      class="fa fa-asterisk"
                      id="asterik"
                      aria-hidden="true"
                    ></i>
                  </p>
                  <p
                    v-else
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                  </p>
                  <div class="input-group">
                    <div class="floating-labels">
                      <div class="row" style="text-align: left">
                        <div
                          class="form-group col-12 m-b-10"
                          v-for="(op, ndx04) in res.demo.demoOptions"
                          :key="ndx04"
                        >
                          <button
                            v-if="op.questOptionId == res.demo.answer"
                            style="background-color: #FF7062"
                            for="radio2"
                            class=""
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="op.questOption"
                            @click="questOptionSelected(ndx03, ndx04)"
                            :class="
                              op.questOptionId == res.demo.answer
                                ? 'set-button'
                                : 'set-button-warning'
                            "
                          >
                            {{ op.questOption }}
                          </button>
                          <button
                            v-else
                            style=""
                            for="radio2"
                            class="set-button-warning"
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="op.questOption"
                            @click="questOptionSelected(ndx03, ndx04)"
                          >
                            {{ op.questOption }}
                          </button>
                          <!-- <label
                            for="radio2"
                            class="btn btn-outline-info label1"
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="op.questOption"
                            @click="demoOptionSelected(ndx03, ndx04)"
                            :class="
                              op.questOptionId == res.demo.answer
                                ? 'btn btn-info label1'
                                : 'btn btn-outline-info label1'
                            "
                            >O{{ ndx04 + 1 }}</label
                          > -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** RADIO BUTTON **** -->

              <div
                class="col-12 m-b-40"
                v-if="res.demo.questionInputTypeId === 4"
              >
                <div
                  class="form-group"
                  style="margin-bottom: 2px !important"
                  onsubmit="return false"
                >
                  <p
                    v-if="res.demo.isRequired == true"
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                    <i
                      class="fa fa-asterisk"
                      id="asterik"
                      aria-hidden="true"
                    ></i>
                  </p>
                  <p
                    v-else
                    class="boldText"
                    style="word-break: break-all; text-align: left"
                  >
                    {{ res.demo.question }}
                  </p>
                </div>
                <div class="input-group">
                  <div class="floating-labels">
                    <div class="row" style="text-align: left">
                      <div
                        class="form-group col-12 m-b-10"
                        v-for="(op, ndx04) in res.demo.demoOptions"
                        :key="ndx04"
                      >
                        <button
                          v-if="op.questOptionId == res.demo.answer"
                          style="background-color: #FF7062"
                          for="radio11"
                          class=""
                          @click="questOptionSelected(ndx03, ndx04)"
                          :class="
                            op.questOptionId == res.demo.answer
                              ? 'set-button'
                              : 'set-button-warning'
                          "
                        >
                          {{ op.questOption }}
                        </button>
                        <button
                          v-else
                          style=""
                          for="radio11"
                          class="set-button-warning"
                          @click="questOptionSelected(ndx03, ndx04)"
                          :class="
                            op.questOptionId == res.demo.answer
                              ? 'set-button'
                              : 'set-button-warning'
                          "
                        >
                          {{ op.questOption }}
                        </button>
                        <!-- <label
                        for="radio11"
                        class="btn btn-outline-info label1"
                        @click="demoOptionSelected(ndx03, ndx04)"
                        :class="
                          op.questOptionId == res.demo.answer
                            ? 'btn btn-info label1'
                            : 'btn btn-outline-info label1'
                        "
                        >{{ op.questOption }}</label
                      > -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- **** EMAIL **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 5">
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p
                      v-if="res.demo.isRequired == true"
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                      <i
                        class="fa fa-asterisk"
                        id="asterik"
                        aria-hidden="true"
                      ></i>
                    </p>
                    <p
                      v-else
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                    </p>
                  </div>
                  <div class="form-group" style="margin-top: -18px">
                    <input
                      type="text"
                      class="form-control required"
                      id=""
                      maxlength="50"
                      placeholder=""
                      v-model="res.demo.answer"
                    />
                  </div>
                </fieldset>
              </div>

              <!-- **** PHONE **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 6">
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p
                      v-if="res.demo.isRequired == true"
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                      <i
                        class="fa fa-asterisk"
                        id="asterik"
                        aria-hidden="true"
                      ></i>
                    </p>
                    <p
                      v-else
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                    </p>
                  </div>
                  <div class="form-group" style="margin-top: -18px">
                    <input
                      v-mask="'###-###-####'"
                      type="tel"
                      class="form-control required"
                      id=""
                      placeholder=""
                      v-model="res.demo.answer"
                    />
                  </div>
                </fieldset>
              </div>

              <!-- **** DATE **** -->
              <div class="col-12" v-if="res.demo.questionInputTypeId === 7">
                <fieldset class="floating-labels">
                  <div class="form-group" style="margin-bottom: 2px !important">
                    <p
                      v-if="res.demo.isRequired == true"
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                      <i
                        class="fa fa-asterisk"
                        id="asterik"
                        aria-hidden="true"
                      ></i>
                    </p>
                    <p
                      v-else
                      class="boldText"
                      style="word-break: break-all; text-align: left"
                    >
                      {{ res.demo.question }}
                    </p>
                  </div>
                  <div class="form-group" style="margin-top: -18px">
                    <input
                      type="date"
                      class="form-control"
                      id=""
                      v-model="res.demo.answer"
                    /><span class="bar"></span>
                  </div>
                </fieldset>
              </div>
            </div>
          </form>

          <!-- ------------------------------------- -->
          <div class="row">
            <div class="card col" id="backbtncard" @click="backStageClick(7)">
              <a href="#">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard" @click="nextStageClick(10)">
              <a href="#">
                <img
                  src="assets/images/buttons/pi.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn"
                />
                <img
                  src="assets/images/buttons/pihover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="nextbtn"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- Questionnaire END -->

    <!-- Patient Information START -->
    <div v-if="currentStep === 11">
      <section id="step-8" class="section active m-b-40">
        <div class="container-fluid form-container slide">
          <div class="col-12" id="strips1">
            <h4 class="font-weight-bold my-3">Visit Information</h4>
          </div>
          <table
            class="table table-responsive table-striped"
            style="table-layout: fixed"
          >
            <tbody>
              <tr>
                <th style="font-weight: bold; text-align: left; width: 250px">
                  Visit Type
                </th>
                <td style="text-align: left; width: 250px" id="td1">
                  {{ activeType.name }}
                </td>
              </tr>
              <tr>
                <th style="font-weight: bold; text-align: left; width: 250px">
                  Visit Reason
                </th>
                <td style="text-align: left; width: 250px" id="td1">
                  {{ activeReason.reasonName }}
                </td>
              </tr>
            </tbody>
          </table>

          <div class="col-12" id="strips1">
            <h4 class="font-weight-bold my-3">Patient Information</h4>
          </div>
          <table
            class="table table-responsive table-striped"
            style="table-layout: fixed"
          >
            <tbody>
              <tr>
                <th style="font-weight: bold; text-align: left; width: 250px">
                  First Name
                </th>
                <td
                  style="word-break: break-all; text-align: left; width: 250px"
                  id="td1"
                >
                  {{ basicDetails.firstName }}
                </td>
              </tr>
              <tr>
                <th style="font-weight: bold; text-align: left; width: 250px">
                  Last Name
                </th>
                <td
                  style="word-break: break-all; text-align: left; width: 250px"
                  id="td1"
                >
                  {{ basicDetails.lastName }}
                </td>
              </tr>
              <tr>
                <th style="font-weight: bold; text-align: left; width: 250px">
                  Date of Birth
                </th>
                <td style="text-align: left; width: 250px" id="td1">
                  {{ newValDOB }}
                </td>
              </tr>
              <tr>
                <th style="font-weight: bold; text-align: left; width: 250px">
                  Sex
                </th>
                <td style="text-align: left; width: 250px" id="td1">
                  {{ basicDetails.gender }}
                </td>
              </tr>
              <!-- <tr>
                <th style="font-weight: bold; text-align: left; width: 250px">
                  SSN
                </th>
                <td style="text-align: left;width: 250px" id="td1">
                  {{ basicDetails.ssn }}
                </td>
              </tr> -->
              <tr v-if="valueSSN == 'SSN'">
                <th style="font-weight: bold; text-align: left; width: 250px">
                  SSN
                </th>
                <td
                  v-if="basicDetails.ssn != ''"
                  id="td1"
                  style="text-align: left; width: 250px"
                >
                  {{ basicDetails.ssn }}
                </td>
                <td v-else id="td1" style="text-align: left; width: 250px">
                  -
                </td>
              </tr>
            </tbody>
          </table>

          <div class="col-12" id="strips1" v-if="checkContact() == true">
            <h4 class="font-weight-bold my-3">Contact Information</h4>
          </div>
          <table
            class="table table-responsive table-striped"
            style="table-layout: fixed"
          >
            <tbody>
              <div v-for="(val, ndxx22) in choseBasic" :key="ndxx22">
                <tr v-if="val.question == 'Email'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Email Address
                  </th>
                  <td id="td1" style="text-align: left; width: 250px">
                    {{ basicDetails.email }}
                    <!-- <a
                    href="/cdn-cgi/l/email-protection"
                    class="__cf_email__"
                    data-cfemail="1360727d6072617a6153747e727a7f3d707c7e"
                    >[email&#160;protected]</a
                  > -->
                  </td>
                </tr>
              </div>

              <div v-for="(val1, ndxx23) in choseBasic" :key="ndxx23">
                <tr v-if="val1.question == 'Phone'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Phone Number
                  </th>
                  <td style="text-align: left; width: 250px" id="td1">
                    {{ basicDetails.phone }}
                  </td>
                </tr>
              </div>
            </tbody>
          </table>

          <div class="col-12" id="strips1">
            <h4 class="font-weight-bold my-3" v-if="checkAddress() == true">
              Address
            </h4>
          </div>
          <table
            class="table table-responsive table-striped"
            style="table-layout: fixed"
          >
            <tbody>
              <div v-for="(val, ndxx11) in choseBasic" :key="ndxx11">
                <tr v-if="val.question == 'Street'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Street
                  </th>
                  <td
                    style="
                      word-break: break-all;
                      text-align: left;
                      width: 250px;
                    "
                    id="td1"
                  >
                    {{ basicDetails.address }}
                  </td>
                </tr>
              </div>

              <div v-for="(val, ndxx12) in choseBasic" :key="ndxx12">
                <tr v-if="val.question == 'City'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    City
                  </th>
                  <td style="text-align: left; width: 250px" id="td1">
                    {{ basicDetails.city }}
                  </td>
                </tr>
              </div>

              <div v-for="(val, ndxx13) in choseBasic" :key="ndxx13">
                <tr v-if="val.question == 'State'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    State
                  </th>
                  <td style="text-align: left; width: 250px" id="td1">
                    {{ basicDetails.state }}
                  </td>
                </tr>
              </div>

              <div v-for="(val, ndxx14) in choseBasic" :key="ndxx14">
                <tr v-if="val.question == 'Zip'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Zip
                  </th>
                  <td style="text-align: left; width: 250px" id="td1">
                    {{ basicDetails.zip }}
                  </td>
                </tr>
              </div>
            </tbody>
          </table>

          <div class="col-12" id="strips1">
            <h4 class="font-weight-bold my-3" v-if="checkInsurance() == true">
              Insurance
            </h4>
          </div>
          <table
            class="table table-responsive table-striped"
            style="table-layout: fixed"
          >
            <tbody>
              <div v-for="(val, ndxx66) in choseBasic" :key="ndxx66">
                <tr v-if="val.question == 'Primary Insurance Name'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Primary Insurance Name
                  </th>
                  <td
                    style="
                      word-break: break-all;
                      text-align: left;
                      width: 250px;
                    "
                    id="td1"
                  >
                    <div v-if="Insurance.primaryInsuranceName != ''">
                      {{ Insurance.primaryInsuranceName }}
                    </div>
                    <div v-else>-</div>
                  </td>
                </tr>
              </div>

              <div v-for="(val, ndxx12) in choseBasic" :key="ndxx12">
                <tr v-if="val.question == 'Primary Insurance Number'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Primary Insurance Number
                  </th>
                  <td style="text-align: left; width: 250px" id="td1">
                    <div v-if="Insurance.primaryInsuranceNumber != ''">
                      {{ Insurance.primaryInsuranceNumber }}
                    </div>
                    <div v-else>-</div>
                  </td>
                </tr>
              </div>

              <div v-for="(val, ndxx13) in choseBasic" :key="ndxx13">
                <tr v-if="val.question == 'Primary Insurance Group Name'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Primary Insurance Group
                  </th>
                  <td style="text-align: left; width: 250px" id="td1">
                    <div v-if="Insurance.primaryInsuranceGroup != ''">
                      {{ Insurance.primaryInsuranceGroup }}
                    </div>
                    <div v-else>-</div>
                  </td>
                </tr>
                <tr v-if="val.question == 'Primary Insurance Image Upload'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Primary Insurance Insurance Image
                  </th>
                  <td style="text-align: left; width: 250px" id="td1">
                    <!-- <div v-if="Insurance.primaryInsuranceId != ''">  -->
                    <img
                      :src="SingleImage.Image"
                      alt=""
                      style="
                        border-radius: 50%;
                        max-width: 100px;
                        margin-top: 10px;
                        margin-bottom: 10px;
                      "
                    />
                    <!-- </div>
                    <div v-else>-</div> -->
                  </td>
                </tr>
              </div>

              <div v-for="(val, ndxx66) in choseBasic" :key="ndxx66">
                <tr v-if="val.question == 'Secondary Insurance Name'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Secondary Insurance Name
                  </th>
                  <td
                    style="
                      word-break: break-all;
                      text-align: left;
                      width: 250px;
                    "
                    id="td1"
                  >
                    <div v-if="Insurance.secondaryInsuranceName != ''">
                      {{ Insurance.secondaryInsuranceName }}
                    </div>
                    <div v-else>-</div>
                  </td>
                </tr>
              </div>

              <div v-for="(val, ndxx12) in choseBasic" :key="ndxx12">
                <tr v-if="val.question == 'Secondary Insurance Number'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Secondary Insurance Number
                  </th>
                  <td style="text-align: left; width: 250px" id="td1">
                    <div v-if="Insurance.secondaryInsuranceNumber != ''">
                      {{ Insurance.secondaryInsuranceNumber }}
                    </div>
                    <div v-else>-</div>
                  </td>
                </tr>
              </div>

              <div v-for="(val, ndxx13) in choseBasic" :key="ndxx13">
                <tr v-if="val.question == 'Secondary Insurance Group Name'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Secondary Insurance group
                  </th>
                  <td style="text-align: left; width: 250px" id="td1">
                    <div v-if="Insurance.secondaryInsuranceGroup != ''">
                      {{ Insurance.secondaryInsuranceGroup }}
                    </div>
                    <div v-else>-</div>
                  </td>
                </tr>
                <tr v-if="val.question == 'Secondary Insurance Image upload'">
                  <th style="font-weight: bold; text-align: left; width: 250px">
                    Secondary Insurance Insurance Image
                  </th>
                  <td style="text-align: left; width: 250px" id="td1">
                    <!-- <div v-if="Insurance.primaryInsuranceId != ''">  -->
                    <img
                      :src="SingleImage1.Image1"
                      alt=""
                      style="
                        border-radius: 50%;
                        max-width: 100px;
                        margin-top: 10px;
                        margin-bottom: 10px;
                      "
                    />
                    <!-- </div>
                    <div v-else>-</div> -->
                  </td>
                </tr>
              </div>
            </tbody>
          </table>

          <div v-if="noDemo == 1">
            <div class="col-12" id="strips1">
              <h4 v-if="reasonDemos.length > 0" class="font-weight-bold my-3">
                Demo Information
              </h4>
            </div>
            <table
              class="table table-responsive table-striped"
              style="table-layout: fixed"
              v-for="(res, key1) in reasonDemos"
              :key="key1"
            >
              <tbody>
                <div v-if="res.demo.questTypeName != ''">
                  <tr>
                    <th
                      style="
                        font-weight: bold;
                        word-break: break-all;
                        text-align: left;
                        width: 250px;
                      "
                    >
                      {{ res.demo.question }}
                    </th>
                    <th
                      style="
                        text-align: left;
                        word-break: break-all;
                        width: 250px;
                      "
                      id="td1"
                    >
                      <div v-if="res.demo.questTypeName == 'Textbox'">
                        <div v-if="res.demo.answer != ''">
                          {{ res.demo.answer }}
                        </div>
                        <div v-else>-</div>
                      </div>
                      <div v-else-if="res.demo.questTypeName == 'Date'">
                        <div v-if="res.demo.answer != 'Invalid date'">
                          {{ res.demo.answer }}
                        </div>
                        <div v-else>-</div>
                      </div>
                      <div v-else-if="res.demo.questTypeName == 'Email'">
                        <div v-if="res.demo.answer != ''">
                          {{ res.demo.answer }}
                        </div>
                        <div v-else>-</div>
                      </div>
                      <div v-else-if="res.demo.questTypeName == 'Phone Number'">
                        <div v-if="res.demo.answer != ''">
                          {{ res.demo.answer }}
                        </div>
                        <div v-else>-</div>
                      </div>
                      <div v-else-if="res.demo.questTypeName == 'Rating'">
                        <div v-if="res.demo.answer != ''">
                          {{
                            getDemoOption(res.demo.demoOptions, res.demo.answer)
                          }}
                        </div>
                        <div v-else>-</div>
                      </div>
                      <div v-else-if="res.demo.questTypeName == 'Radio'">
                        <div v-if="res.demo.answer != ''">
                          {{
                            getDemoOption(res.demo.demoOptions, res.demo.answer)
                          }}
                        </div>
                        <div v-else>-</div>
                      </div>
                      <div v-else>
                        {{ getDemoAns(res.demo.answer, key1) }}
                      </div>
                    </th>
                  </tr>
                </div>
              </tbody>
            </table>
          </div>

          <div class="col-12" id="strips1">
            <h4 v-if="reasonQuests.length > 0" class="font-weight-bold my-3">
              Questionaire Information
            </h4>
          </div>
          <table
            class="table table-responsive table-striped"
            style="table-layout: fixed"
            v-for="(res, key) in reasonQuests"
            :key="key"
          >
            <tbody>
              <tr>
                <th
                  style="
                    font-weight: bold;
                    word-break: break-all;
                    text-align: left;
                    width: 250px;
                  "
                >
                  {{ res.demo.question }}
                </th>
                <th
                  style="text-align: left; word-break: break-all; width: 250px"
                  id="td1"
                >
                  <div v-if="res.demo.questTypeName == 'Textbox'">
                    <div v-if="res.demo.answer != ''">
                      {{ res.demo.answer }}
                    </div>
                    <div v-else>-</div>
                  </div>
                  <div v-else-if="res.demo.questTypeName == 'Date'">
                    <div v-if="res.demo.answer != 'Invalid date'">
                      {{ res.demo.answer }}
                    </div>
                    <div v-else>-</div>
                  </div>
                  <div v-else-if="res.demo.questTypeName == 'Email'">
                    <div v-if="res.demo.answer != ''">
                      {{ res.demo.answer }}
                    </div>
                    <div v-else>-</div>
                  </div>
                  <div v-else-if="res.demo.questTypeName == 'Phone Number'">
                    <div v-if="res.demo.answer != ''">
                      {{ res.demo.answer }}
                    </div>
                    <div v-else>-</div>
                  </div>
                  <div v-else-if="res.demo.questTypeName == 'Rating'">
                    <div v-if="res.demo.answer != ''">
                      {{ getDemoOption(res.demo.demoOptions, res.demo.answer) }}
                    </div>
                    <div v-else>-</div>
                  </div>
                  <div v-else-if="res.demo.questTypeName == 'Radio'">
                    <div v-if="res.demo.answer != ''">
                      {{ getDemoOption(res.demo.demoOptions, res.demo.answer) }}
                    </div>
                    <div v-else>-</div>
                  </div>
                  <div v-else>
                    {{ getQuestAns(res.demo.answer, key) }}
                  </div>
                </th>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="card col" id="backbtncard" @click="backStageClick(8)">
              <a href="#">
                <img
                  src="assets/images/buttons/ba.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="backbtn"
                />
                <img
                  src="assets/images/buttons/bahover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="backbtn"
                />
              </a>
            </div>

            <div class="card col" id="nextbtncard" @click="saveCheckinInfo">
              <a href="#">
                <img
                  src="assets/images/buttons/se.png"
                  alt=""
                  class="img-fluid btn-start"
                  id="nextbtn99"
                />
                <img
                  src="assets/images/buttons/sehover.png"
                  alt=""
                  class="img-fluid btn-start img-top"
                  id="prevbtn111"
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section id="step-9" class="section active m-b-40">
        <div class="container form-container slide">
          <h3 class="text-center boldText">THANK YOU FOR VISITING VEINS</h3>
        </div>
      </section>
    </div>
    <!-- Patient Information END -->

    <!-- Thanks Message START -->
    <!-- <div v-if="currentStep === 11">
      <section id="step-9" class="section active m-b-40">
        <div class="container form-container slide">
          <h3 class="text-center boldText">THANK YOU FOR VISITING VEINS</h3>
        </div>
      </section>
    </div> -->
    <!-- Thanks Message END -->

    <!-- 2nd div -->
    <div v-if="currentStep === 100">
      <section id="step-3" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">
            Please Enter Veins ID
          </h3>
          <form class="floating-labels" @submit.prevent="onSubmit(event)">
            <!-- third row -->
            <div class="row">
              <div class="col-lg-12">
                <div
                  class="form-group m-b-40"
                  v-bind:class="[veinsId != 0 ? 'focused' : ' ']"
                >
                  <input
                    v-model="veinsId"
                    type="number"
                    class="form-control required"
                    id=""
                    placeholder=""
                  /><span class="bar"></span>
                  <label for="" style="margin-left: -50%">Veins ID</label>
                </div>
              </div>

              <button
                @click="verifyClick(100)"
                class="btn btn-outline-success col-12"
              >
                Verify
              </button>
              <!-- <button
              class="btn btn-outline-success waves-effect col-12 m-b-10"
              data-dismiss="modal"
            >
              Profile Found
            </button>
            <button
              class="btn btn-outline-danger waves-effect col-12"
              type="button"
              data-toggle="modal"
              data-target="#profileNotFound"
            >
              Profile Not Found
            </button> -->
            </div>
            <!-- third row -->
          </form>
        </div>
      </section>
    </div>

    <!-- Confirm DOB -->
    <div v-if="currentStep === 333">
      <section id="step-4" class="section active m-b-40">
        <div class="container form-container">
          <h3 class="font-weight-bold h3Spacing text-center">Date Of Birth</h3>
          <form class="floating-labels">
            <!-- third row -->
            <div class="alert alert-success text-center">
              Looks like we found your profile! Profile Enter your DOB to verify
              your identity
            </div>
            <form action="" @submit.prevent="onSubmit(event)">
              <div class="form-group">
                <input
                  v-model="verifyDate"
                  type="date"
                  class="form-control"
                  id=""
                  name=""
                />
              </div>

              <button
                class="btn btn-outline-success waves-effect waves-light col-12"
                @click="verifyClickDate()"
              >
                Verify
              </button>
            </form>
            <!-- third row -->
          </form>
        </div>
      </section>
    </div>
  </div>

  <!-- Show Image Crop Part-->
  <div
    class="modal bs-example-modal-lg fade"
    id="showPictureModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    style="display: none"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Crop Image</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
            @click="closePracticeModal"
          >
            x
          </button>
        </div>
        <div class="modal-body">
          <cropper
            ref="croppieRef"
            class="cropper"
            :src="SingleImage.Image"
            :stencil-props="{
              handler: {},
              aspectRatio: 10 / 12,
              movable: false,
              scalable: false,
            }"
            :resize-image="{ adjustStencil: false }"
            image-restriction="stencil"
            @change="changePrimIns()"
          />
          <div class="col-md-12 pl0 talignc">
            <button
              type="button"
              id="butt1"
              class="btn btn-primary"
              @click="finishCropping('crop')"
            >
              OK
            </button>
            <button
              type="button"
              id="butt2"
              class="btn btn-primary"
              @click="finishCropping"
            >
              Cancel
            </button>
          </div>
          <div style="width: 100%; text-align: center">
            <!-- <img id="image" ref="myimage" :src="SingleImage.Image"  /> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Show Image Crop Part-->
  <div
    class="modal bs-example-modal-lg fade"
    id="showPictureModal1"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    style="display: none"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Crop Image</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
            @click="closePracticeModal"
          >
            x
          </button>
        </div>
        <div class="modal-body">
          <cropper
            ref="croppieRef1"
            class="cropper"
            :src="SingleImage1.Image1"
            :stencil-props="{
              handler: {},
              aspectRatio: 10 / 12,
              movable: false,
              scalable: false,
            }"
            :resize-image="{ adjustStencil: false }"
            image-restriction="stencil"
            @change="changeSecIns"
          />
          <div class="col-md-12 pl0 talignc">
            <button
              type="button"
              id="butt3"
              class="btn btn-primary"
              @click="finishCropping1('crop')"
            >
              OK
            </button>
            <button
              type="button"
              id="butt4"
              class="btn btn-primary"
              @click="finishCropping1"
            >
              Cancel
            </button>
          </div>
          <div style="width: 100%; text-align: center">
            <!-- <img id="image" ref="myimage" :src="SingleImage.Image"  /> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Grouping Section -->

  <section class="section active m-b-40" v-if="currentStep === 12">
    <div class="container form-container text-center slide">
      <div class="container text-center">
        <h3 class="font-weight-bold text-uppercase">
          Do you want to check-in any other patients?
        </h3>
      </div>

      <div
        class="mb-3"
        v-if="patientList !== null"
      >
        <div class="col-12">
          <h4 class="font-weight-bold my-3" id="strips1">Patients you have checked in.</h4>
        </div>
        <table
          class="table table-responsive table-striped"
          style="table-layout: fixed"
        >
          <tbody>
            <tr v-for="patient in patientList"
                :key="patient.groupId">
              <td
                style="text-align: center; width: 100vw"
                
              >
                {{ patient.firstName + " " + patient.lastNameInitial }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row">
        <div class="card col">
          <button
            type="button"
            class="btn btn-warning"
            @click="cancelAddingMorePatients"
          >
            No
          </button>
        </div>

        <div class="card col">
          <button
            type="button"
            class="btn btn-success"
            @click="addMorePatients"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

// import $ from "jquery";

export default {
  name: "Home",
  components: {
    Cropper,
  },
  data() {
    return {
      locationName: "",
      day: null,
      month: null,
      year: null,
      refreshCount: "",
      contactInfo: ["phone", "email"],
      addressInfo: ["street", "city", "zip", "state"],
      insuranceInfo: [
        "primary insurance name",
        "primary insurance number",
        "primary insurance group name",
        "primary insurance image upload",
        "secondary insurance name",
        "secondary insurance number",
        "secondary insurance group name",
        "secondary insurance image upload",
      ],
      callOnce: false,
      valueSSN: "",

      //Image Crop
      SingleImage: {
        image: "",
      },
      SingleImage1: {
        image1: "",
      },
      locationFile: "",
      fileName: null,
      locationFile1: "",
      fileName1: null,

      img1: {},
      img: {},
      cropper: {},

      questCheckBoxSelected: [],
      demoCheckBoxSelected: [],
      basicDetail: [],
      phoneVal: "",
      emailVal: "",
      ssnVal: "",
      ssnRequire: 0,
      emailRq: 0,
      phoneRq: 0,
      zipRq: 0,
      stateRq: 0,
      cityRq: 0,
      streetRq: 0,

      cityVal: "",
      stateVal: "",
      zipVal: "",
      addVal: "",
      demoClick: [],
      primaryInsuranceName: "",
      primaryInsNRq: 0,
      primaryInsuranceNumber: "",
      primaryInsNumRq: 0,
      primaryInsuranceGroup: "",
      primaryInsGrpRq: 0,
      primaryInsuranceId: "",
      primaryInsImage: 0,

      secondaryInsuranceName: "",
      secondaryInsNRq: 0,
      secondaryInsuranceNumber: "",
      secondaryInsNumRq: 0,
      secondaryInsuranceGroup: "",
      secondaryInsGrpRq: 0,
      secondaryInsuranceId: "",
      secondaryInsImage: 0,

      //loader
      loader: "",
      newValDOB: "",
      checkinType: "",
      value: null,
      veinsId: "",
      verifyDate: "",
      patientsIdsLst: [],
      currentStep: 1,
      types: [],
      reasons: [],
      demos: [],
      demos_1: [],
      noDemo: 0,
      choseBasic: [],

      quests: [],
      actualDemos: [],
      actualQuestions: [],
      questionOptions: [],
      visitTypeQuestDemo: [],
      basicDetails: {
        pndx: 0,
        patientId: 0,
        firstName: "",
        lastName: "",
        currentdate: new Date(),
        dos: "",
        dob: "",
        gender: "",
        ssn: "",
        phone: "",
        email: "",
        address: "",
        city: "",
        zip: "",
        state: "",
      },
      Insurance: {
        primaryInsuranceName: "",
        primaryInsuranceNumber: "",
        primaryInsuranceGroup: "",
        primaryInsuranceId: "",
        secondaryInsuranceName: "",
        secondaryInsuranceNumber: "",
        secondaryInsuranceGroup: "",
        secondaryInsuranceId: "",
      },

      secondaryImage: "",
      primaryImage: "",

      activeType: "",
      activeReason: "",
      visitTypeReasons: "",
      currentSelectedTypeId: -1,
      currentSelectedReasonId: -1,
      reasonQuests: [],
      reasonDemos: [],
      activeDemo: {
        reasonId: 0,
        visitDetailId: 0,
        demo: {
          questId: 0,
          srNo: 0,
          questName: "",
          question: "",
          answer: "",
          questionInputTypeId: 0,
          questTypeName: "",
          demoOptions: {
            srNo: 0,
            questOption: "",
          },
        },
      },
      patientList: null,
      groupId: "",
      groupColor: "",
    };
  }, // data
  methods: {
    //Image Set
    finishCropping(eventType) {
      if (eventType == "crop") {
        var objData = this.$refs.croppieRef.getResult();
        this.SingleImage.Image = objData.canvas.toDataURL();
      }
      //window.$(".dropify-render img")[0].src=this.SingleImage.Image;
      window.$("#showPictureModal").hide();
      window.$("#showPictureModal").modal("hide");
    },
    changePrimIns({ coordinates, canvas }) {
      console.log(coordinates, canvas);
    },
    changeSecIns({ coordinates, canvas }) {
      console.log(coordinates, canvas);
    },
    finishCropping1(eventType) {
      if (eventType == "crop") {
        var objData = this.$refs.croppieRef1.getResult();
        this.SingleImage1.Image1 = objData.canvas.toDataURL();
      }
      //window.$(".dropify-render img")[0].src=this.SingleImage.Image;
      window.$("#showPictureModal1").hide();
      window.$("#showPictureModal1").modal("hide");
    },
    getImage(event) {
      event.preventDefault();
      window.$("#showPictureModal").modal();
      window.$("#showPictureModal").show();
      this.fileName = event.target.files[0].name;
      this.locationFile = event.target.value;
      var reader = new FileReader();
      reader.onload = () => {
        this.SingleImage.Image = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
      this.primaryImage = event.target.files[0].name;
      this.ImageCropper();
    },
    ImageCropper() {
      this.img11 = this.$refs.myimage;
    },

    getImage1(event) {
      event.preventDefault();
      window.$("#showPictureModal1").modal();
      window.$("#showPictureModal1").show();
      this.fileName1 = event.target.files[0].name;
      this.locationFile1 = event.target.value;
      var reader = new FileReader();
      reader.onload = () => {
        this.SingleImage1.Image1 = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
      this.secondaryImage = event.target.files[0].name;
      this.ImageCropper1();
    },
    ImageCropper1() {
      this.img1 = this.$refs.myimage1;
    },
    //check values
    checkContact() {
      for (let j = 0; j < this.choseBasic.length; j++) {
        if (
          this.choseBasic[j].question == "Email" ||
          this.choseBasic[j].question == "Phone"
        ) {
          return true;
        }
      }
      return false;
    },
    checkAddress() {
      for (let k = 0; k < this.choseBasic.length; k++) {
        if (
          this.choseBasic[k].question == "Street" ||
          this.choseBasic[k].question == "Zip" ||
          this.choseBasic[k].question == "City" ||
          this.choseBasic[k].question == "State"
        ) {
          return true;
        }
      }
      return false;
    },
    checkInsurance() {
      for (let r = 0; r < this.choseBasic.length; r++) {
        if (
          this.choseBasic[r].question == "Primary Insurance Name" ||
          this.choseBasic[r].question == "Primary Insurance Group" ||
          this.choseBasic[r].question == "Primary Insurance Number" ||
          this.choseBasic[r].question == "Secondary Insurance Name" ||
          this.choseBasic[r].question == "Secondary Insurance Group Name" ||
          this.choseBasic[r].question == "Secondary Insurance Number"
        ) {
          return true;
        }
      }
      return false;
    },
    getQuestAns(answer, indx) {
      let str = "";
      answer = answer.toString();
      const obj = this.reasonQuests[indx].demo.demoOptions;
      var ans = "";
      if (answer.includes(",")) {
        ans = answer.split(",");
      } else {
        ans = answer;
        for (let l = 0; l < obj.length; l++) {
          if (ans == obj[l].questOptionId) {
            str = obj[l].questOption;
          }
        }
        if (str == "") {
          str = "-";
          return str;
        }
        return str;
      }
      for (let i = 0; i < ans.length; i++) {
        for (let j = 0; j < obj.length; j++) {
          if (ans[i] == obj[j].questOptionId) {
            str += obj[j].questOption + ",";
          }
        }
      }
      str = str.slice(0, -1);
      if (str == "") {
        str = "-";
        return str;
      }
      return str;
    },
    getDemoAns(answer, indx) {
      let str1 = "";
      answer = answer.toString();
      const obj1 = this.reasonDemos[indx].demo.demoOptions;
      var ans1 = "";
      if (answer.includes(",")) {
        ans1 = answer.split(",");
      } else {
        ans1 = answer;
        for (let k = 0; k < obj1.length; k++) {
          if (ans1 == obj1[k].questOptionId) {
            str1 = obj1[k].questOption;
          }
        }
        if (str1 == "") {
          str1 = "-";
          return str1;
        }
        return str1;
      }
      for (let i = 0; i < ans1.length; i++) {
        for (let j = 0; j < obj1.length; j++) {
          if (ans1[i] == obj1[j].questOptionId) {
            str1 += obj1[j].questOption + ",";
          }
        }
      }
      str1 = str1.slice(0, -1);
      if (str1 == "") {
        str1 = "-";
        return str1;
      }
      return str1;
    },
    setBasicRadio(val) {
      this.basicDetails.gender = val;
    },
    checkinTypeClick(para, step) {
      if (para == "checkin") {
        this.checkinType = para;
      } else {
        this.checkinType = para;
      }
      this.currentStep = step;
    },

    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },

    saveCheckinInfo() {
      //let bd = this.basicDetails;
      let currentdate = new Date();
      this.basicDetails.dos =
        currentdate.getFullYear() +
        "-" +
        String(currentdate.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(currentdate.getDate()).padStart(2, "0") +
        " " +
        String(currentdate.getHours()).padStart(2, "0") +
        ":" +
        String(currentdate.getMinutes()).padStart(2, "0") +
        ":" +
        String(currentdate.getSeconds()).padStart(2, "0");
      this.basicDetails.ExternalId = this.veinsId; // ***new
      this.basicDetails.physicianId = this.activeReason.physicianId;
      //Image set
      if (typeof this.SingleImage.Image === "undefined") {
        console.log("ok");
      } else {
        var str = this.SingleImage.Image;
        str = str.substring(22);
        if (str.charAt(0) == ",") {
          str = str.substring(1);
        }
        this.Insurance.imageStrPrimary = str;
      }

      if (typeof this.SingleImage1.Image1 === "undefined") {
        console.log("ok");
      } else {
        var str1 = this.SingleImage1.Image1;
        str1 = str1.substring(22);
        if (str1.charAt(0) == ",") {
          str1 = str1.substring(1);
        }
        this.Insurance.imageStrSecondry = str1;
      }

      this.Insurance.imagePrimName = this.primaryImage;
      this.Insurance.imageSecName = this.secondaryImage;

      if (this.Insurance.primaryInsuranceName != "") {
        this.Insurance.Count = 1;
      } else if (this.Insurance.secondaryInsuranceName != "") {
        this.Insurance.Count = 1;
      } else if (this.Insurance.primaryInsuranceNumber != "") {
        this.Insurance.Count = 1;
      } else if (this.Insurance.primaryInsuranceGroup != "") {
        this.Insurance.Count = 1;
      } else if (this.Insurance.secondaryInsuranceGroup != "") {
        this.Insurance.Count = 1;
      } else if (this.Insurance.secondaryInsuranceNumber != "") {
        this.Insurance.Count = 1;
      } else if (this.Insurance.imagePrimName != "") {
        this.Insurance.Count = 1;
      } else if (this.Insurance.imageSecName != "") {
        this.Insurance.Count = 1;
      } else {
        this.Insurance.Count = 0;
      }

      if (this.groupId === "") {
        this.groupId = new Date().getTime().toString();
      }

      let mydata = {
        visitTypeId: this.activeType.visitTypeId,
        visitDetailId: this.activeReason.visitDetailId,
        questDemos: [],
        basicDetail: this.basicDetails,
        Insurance: this.Insurance,
        dc: this.dummyComm,
        groupId: this.groupId,
        groupColor: this.groupColor,
      };
      let x = this.reasonDemos.length;
      for (let i = 0; i < x; i++) {
        const obj = {
          questId: this.reasonDemos[i].demo.questId,
          answer: this.reasonDemos[i].demo.answer,
          isDemo: 1,
        };
        mydata.questDemos.push(obj);
      }
      x = this.reasonQuests.length;
      for (let i = 0; i < x; i++) {
        const obj = {
          questId: this.reasonQuests[i].demo.questId,
          answer: this.reasonQuests[i].demo.answer,
          isDemo: 0,
        };
        mydata.questDemos.push(obj);
      }
      this.intDummyComm();
      this.dummyComm.emailValue = this.basicDetails.email;
      this.dummyComm.smsValue = this.basicDetails.phone;
      this.dummyComm.prId = localStorage.xeon;
      this.dummyComm.extras = this.veinsId; // ***new
      mydata.dc = this.dummyComm;
      mydata.PhysicianId = this.PhysicianId;
      const url = this.SERVER + "/VNSPRAAPI/Checkin/SvChknPat";
      //const paraData = { dc: this.dummyComm, data: mydata};
      //this.axiosGetData(url, mydata, 2);
      this.valueSSN = "";
      this.loader_1();
      this.axiosGetData(url, mydata, 2);
      //this.$router.go(0);
    },

    demoOptionSelected(ndx1, ndx2, what = "") {
      if (what == "check-box") {
        const ans = this.reasonDemos[ndx1].demo.demoOptions[ndx2].questOptionId;
        if (this.demoCheckBoxSelected.includes(ans)) {
          for (var i = 0; i < this.demoCheckBoxSelected.length; i++) {
            if (this.demoCheckBoxSelected[i] === ans) {
              this.demoCheckBoxSelected.splice(i, 1);
              i--;
            }
          }
        } else {
          this.demoCheckBoxSelected.push(ans);
        }
        this.reasonDemos[
          ndx1
        ].demo.answer = this.demoCheckBoxSelected.toString();
      } else
        this.reasonDemos[ndx1].demo.answer = this.reasonDemos[
          ndx1
        ].demo.demoOptions[ndx2].questOptionId;
      return false;
    },

    questOptionSelected(ndx1, ndx2, what) {
      if (what == "check-box") {
        const ans = this.reasonQuests[ndx1].demo.demoOptions[ndx2]
          .questOptionId;
        if (this.questCheckBoxSelected.includes(ans)) {
          for (var i = 0; i < this.questCheckBoxSelected.length; i++) {
            if (this.questCheckBoxSelected[i] === ans) {
              this.questCheckBoxSelected.splice(i, 1);
              i--;
            }
          }
        } else {
          this.questCheckBoxSelected.push(ans);
        }
        this.reasonQuests[
          ndx1
        ].demo.answer = this.questCheckBoxSelected.toString();
      } else
        this.reasonQuests[ndx1].demo.answer = this.reasonQuests[
          ndx1
        ].demo.demoOptions[ndx2].questOptionId;
      return false;
    },

    makeReasonQuests() {
      this.reasonQuests = [];
      //let obj = this.actualQuestions;
      let obj = this.blankActiveDemo();

      if (this.actualQuestions.length != 0) {
        obj.visitDetailId = this.activeReason.visitDetailId;
        let x = this.visitTypeQuestDemo.length;
        for (let i = 0; i < x; i++) {
          if (
            this.visitTypeQuestDemo[i].isDemo == 0 &&
            this.visitTypeQuestDemo[i].visitDetailId == obj.visitDetailId
          ) {
            obj = this.blankActiveDemo();
            obj.visitDetailId = this.activeReason.visitDetailId;
            obj.demo.questId = this.visitTypeQuestDemo[i].questId;
            obj.demo.srNo = this.visitTypeQuestDemo[i].srNo;
            obj.demo.isRequired = this.visitTypeQuestDemo[i].isRequired;
            let y = this.actualQuestions.length;
            for (let j = 0; j < y; j++) {
              if (this.actualQuestions[j].questId == obj.demo.questId) {
                obj.demo.questName = this.actualQuestions[j].questName;
                obj.demo.answer = this.actualQuestions[j].answer;
                obj.demo.question = this.actualQuestions[j].question;
                //obj.demo.isRequired = this.actualQuestions[j].isRequired;
                obj.demo.questTypeName = this.actualQuestions[j].questTypeName;
                obj.demo.questionInputTypeId = this.actualQuestions[
                  j
                ].questionInputTypeId;
                break;
              }
            }
            y = this.questionOptions.length;
            for (let j = 0; j < y; j++) {
              if (this.questionOptions[j].questId == obj.demo.questId) {
                let objP = {
                  questId: obj.demo.questId,
                  questOption: this.questionOptions[j].questOption,
                  questOptionId: this.questionOptions[j].questOptionId,
                };
                obj.demo.demoOptions.push(objP);
              }
            }
            this.reasonQuests.push(obj);
            console.log(obj);
          }
        } // main if
      } // main forzzzzzzz,mjb
    },
    makeReasonDemos() {
      this.reasonDemos = [];
      //let obj = this.actualDemo;
      let obj = this.blankActiveDemo();
      obj.visitDetailId = this.activeReason.visitDetailId;
      let x = this.visitTypeQuestDemo.length;
      if (this.actualDemos.length != 0) {
        for (let i = 0; i < x; i++) {
          if (
            this.visitTypeQuestDemo[i].isDemo == 1 &&
            this.visitTypeQuestDemo[i].visitDetailId == obj.visitDetailId
          ) {
            //alert(9999);
            obj = this.blankActiveDemo();
            obj.visitDetailId = this.activeReason.visitDetailId;
            obj.demo.questId = this.visitTypeQuestDemo[i].questId;
            obj.demo.srNo = this.visitTypeQuestDemo[i].srNo;
            obj.demo.isRequired = this.visitTypeQuestDemo[i].isRequired;
            let y = this.actualDemos.length;
            for (let j = 0; j < y; j++) {
              //console.log(this.actualDemos[j].questId , obj.demo.questId);
              if (this.actualDemos[j].questId == obj.demo.questId) {
                obj.demo.questName = this.actualDemos[j].questName;
                obj.demo.answer = this.actualDemos[j].answer;
                //obj.demo.isRequired = this.actualDemos[j].isRequired;
                obj.demo.question = this.actualDemos[j].question;
                obj.demo.questTypeName = this.actualDemos[j].questTypeName;
                obj.demo.questionInputTypeId = this.actualDemos[
                  j
                ].questionInputTypeId;
                {
                  //alert(9999);
                  break;
                }
              }
            }
            y = this.questionOptions.length;
            for (let j = 0; j < y; j++) {
              if (this.questionOptions[j].questId == obj.demo.questId) {
                let objP = {
                  questId: obj.demo.questId,
                  questOption: this.questionOptions[j].questOption,
                  questOptionId: this.questionOptions[j].questOptionId,
                };
                obj.demo.demoOptions.push(objP);
              }
            }
            this.reasonDemos.push(obj);
            //console.log(obj);
          }
        } // main if
      } // main for
    },
    blankActiveDemo() {
      this.activeDemo = {
        reasonId: 0,
        visitDetailId: 0,
        setValue: 0,
        PhysicianId: "",
        demo: {
          questId: 0,
          srNo: 0,
          questName: "",
          question: "",
          answer: "",
          questionInputTypeId: 0,
          questTypeName: "",
          demoOptions: [
            //   {
            //   srNo: 0,
            //   questOption: "",
            // }
          ],
        },
      };
      return this.activeDemo;
    },
    reasonClick(ndx) {
      this.currentSelectedReasonId = this.visitTypeReasons[ndx].visitDetailId;
      this.activeReason = "";
      this.activeReason = JSON.parse(
        JSON.stringify(this.visitTypeReasons[ndx])
      );
      this.PhysicianId = this.visitTypeReasons[0].physicianId;
      this.makeReasonDemos();
      this.makeReasonQuests();

      //setBasic Detail
      this.choseBasic = [];
      this.demoClick = this.demos_1.filter(
        (i) => i.visitDetailId == this.currentSelectedReasonId
      );
      this.filterList();
    },
    filterList() {
      for (let i = 0; i < this.demoClick.length; i++) {
        if (
          this.demoClick[i].question == "First Name" ||
          this.demoClick[i].question == "LastName" ||
          this.demoClick[i].question == "DOB" ||
          this.demoClick[i].question == "SSN" ||
          this.demoClick[i].question == "Gender" ||
          this.demoClick[i].question == "Phone" ||
          this.demoClick[i].question == "Email" ||
          this.demoClick[i].question == "Street" ||
          this.demoClick[i].question == "City" ||
          this.demoClick[i].question == "Zip" ||
          this.demoClick[i].question == "State" ||
          this.demoClick[i].question == "Primary Insurance Name" ||
          this.demoClick[i].question == "ExternalId" ||
          this.demoClick[i].question == "Primary Insurance Number" ||
          this.demoClick[i].question == "Primary Insurance Group Name" ||
          this.demoClick[i].question == "Primary Insurance Image Upload" ||
          this.demoClick[i].question == "Secondary Insurance Name" ||
          this.demoClick[i].question == "Secondary Insurance Number" ||
          this.demoClick[i].question == "Secondary Insurance Group Name" ||
          this.demoClick[i].question == "Secondary Insurance Image upload"
        ) {
          this.choseBasic.push(this.demoClick[i]);
        }
      }
      this.demoClick = [];
    },
    visitTypeClick(ndx) {
      this.currentSelectedTypeId = this.types[ndx].visitTypeId;
      this.activeType = JSON.parse(JSON.stringify(this.types[ndx]));
      this.visitTypeReasons = [];
      const x = this.reasons.length;
      for (let i = 0; i < x; i++) {
        if (this.reasons[i].visitTypeId === this.activeType.visitTypeId) {
          this.visitTypeReasons.push(
            JSON.parse(JSON.stringify(this.reasons[i]))
          );
        }
      }
      this.activeReason = "";
      this.activeReason = JSON.parse(JSON.stringify(this.visitTypeReasons[0]));
    },
    verifyClick(step) {
      // Express stage 1
      if (step == 100) {
        let found = false;
        for (let i = 0; i < this.patientsIdsLst.length; i++) {
          if (this.patientsIdsLst[i] == this.veinsId) {
            found = true;
            break;
          }
        }
        if (found) {
          this.currentStep = 333;
        } else {
          this.currentStep = 4;
          this.alertShown = 1;
        }
      }
    },
    verifyClickDate() {
      if (!this.isValidateDate(this.verifyDate)) {
        this.warningToast("Valid Date of Birth required");
        event.preventDefault();
        return;
      }
      this.dummyComm.Extras = this.veinsId;
      //this.dummyComm.myData = this.verifyDate;
      this.dummyComm.myTime = this.verifyDate;
      event.preventDefault();
      const url = this.SERVER + "/VNSPRAAPI/Checkin/CHKPATDOB";
      this.axiosPostDOB(url);
    },
    async axiosPostDOB(Url) {
      await axios({
        method: "post",
        data: this.dummyComm,
        url: Url,
      })
        .then((res) => {
          const result = res.data;
          if (result.patientId == -1) {
            this.currentStep = 4;
            this.alertShown = 1;
          } else {
            const dd = new Date(result.dob);
            const ds = dd.toLocaleDateString();
            this.basicDetails.patientId = result.patientId;
            this.basicDetails.firstName = result.firstName;
            this.basicDetails.lastName = result.lastName;
            this.basicDetails.dob = ds;
            this.basicDetails.gender = result.gender;
            this.basicDetails.ssn = result.ssn;
            this.basicDetails.phone = result.phone;
            this.basicDetails.email = result.email;
            this.basicDetails.address = result.address;
            this.basicDetails.city = result.city;
            this.basicDetails.zip = result.zip;
            this.basicDetails.state = result.state;
            this.setValue = 1;
            this.currentStep = 7;
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {});

      this.fileName = null;
      this.fileName1 = null;
    },
    //get Answer
    getDemoOption(demo, answer) {
      for (let g = 0; g < demo.length; g++) {
        if (demo[g].questOptionId == answer) {
          return demo[g].questOption;
        }
      }
    },

    backStageClick(step) {
      window.scrollTo(0, 0);
      if (step === 8) {
        //for reasonQuest
        for (var i = 0; i < this.reasonQuests.length; i++) {
          if (this.reasonQuests[i].demo.questTypeName == "Date") {
            this.reasonQuests[i].demo.answer = moment(
              String(this.reasonQuests[i].demo.answer)
            ).format("YYYY-MM-DD");
          }
        }

        //for Demos
        for (var k = 0; k < this.reasonDemos.length; k++) {
          if (this.reasonDemos[k].demo.questTypeName == "Date") {
            this.reasonDemos[k].demo.answer = moment(
              String(this.reasonDemos[k].demo.answer)
            ).format("YYYY-MM-DD");
          }
        }

        let found = false;
        if (this.reasonQuests.length == 0) {
          this.currentStep = 9;
          found = true;
        } else {
          this.currentStep = 10;
          return;
        }

        if (found == true) {
          if (this.noDemo == 0) {
            if (this.isInsuranceFound() == true) {
              this.currentStep = 8;
              return;
            } else if (this.isAddressFound() == true) {
              this.currentStep = 7;
              return;
            } else if (this.isCustomFound() == true) {
              this.currentStep = 6;
              return;
            } else {
              this.currentStep = 4;
              return;
            }
          } else {
            this.currentStep = 9;
            return;
          }
        }
      }

      if (step == 7) {
        for (var j = 0; j < this.reasonDemos.length; j++) {
          if (this.reasonDemos[j].demo.questTypeName == "Date") {
            this.reasonDemos[j].demo.answer = moment(
              String(this.reasonDemos[j].demo.answer)
            ).format("YYYY-MM-DD");
          }
        }
        let found1 = false;
        if (this.noDemo == 0) {
          this.currentStep = 8;
          found1 = true;
        } else {
          this.currentStep = 9;
          return;
        }

        if (found1 == true) {
          if (this.isInsuranceFound() == true) {
            this.currentStep = 8;
            return;
          } else if (this.isAddressFound() == true) {
            this.currentStep = 7;
            return;
          } else if (this.isCustomFound() == true) {
            this.currentStep = 6;
            return;
          } else {
            this.currentStep = 4;
            return;
          }
        }
      }

      if (step == 6) {
        if (this.isInsuranceFound() == true) {
          this.currentStep = 8;
          return;
        } else if (this.isAddressFound() == true) {
          this.currentStep = 7;
          return;
        } else if (this.isCustomFound() == true) {
          this.currentStep = 6;
          return;
        } else {
          this.currentStep = 4;
          return;
        }
      }

      if (step == 5) {
        if (this.isAddressFound() == true) {
          this.currentStep = 7;
          return;
        } else if (this.isCustomFound() == true) {
          this.currentStep = 6;
          return;
        } else {
          this.currentStep = 4;
          return;
        }
      }

      if (step == 4) {
        if (this.isCustomFound() == true) {
          this.currentStep = 6;
          return;
        } else {
          this.currentStep = 4;
          return;
        }
      }
    },

    isCustomFound() {
      let found = false;
      for (let c = 0; c < this.contactInfo.length; c++) {
        for (let b = 0; b < this.choseBasic.length; b++) {
          if (
            this.contactInfo[c] == this.choseBasic[b].question.toLowerCase()
          ) {
            found = true;
            break;
          }
        }
      }
      return found;
    },

    isAddressFound() {
      let found = false;
      for (let c = 0; c < this.addressInfo.length; c++) {
        for (let b = 0; b < this.choseBasic.length; b++) {
          if (
            this.addressInfo[c] == this.choseBasic[b].question.toLowerCase()
          ) {
            found = true;
            break;
          }
        }
      }
      return found;
    },

    isInsuranceFound() {
      let found = false;
      for (let c = 0; c < this.insuranceInfo.length; c++) {
        for (let b = 0; b < this.choseBasic.length; b++) {
          if (
            this.insuranceInfo[c] == this.choseBasic[b].question.toLowerCase()
          ) {
            found = true;
            break;
          }
        }
      }
      return found;
    },

    countDemos() {
      let demoLength;
      //         for(let k=0;k<demoLength;k++){
      //             if(this.reasonDemos[k].demo.question == ""){
      //                 this.reasonDemos.splice(k, 1);
      //                 //demoLength--;
      //         }
      //      }
      demoLength = this.reasonDemos.filter((i) => i.demo.question != "");

      //count Demo
      if (demoLength == 0) {
        this.noDemo = 0;
      } else {
        this.noDemo = 1;
      }
      this.reasonDemos = this.reasonDemos.filter((i) => i.demo.question != "");
    },

    //**nextStageClick(step)
    nextStageClick(step) {
      //splice Demo
      if (step == 4) {
        this.countDemos();
      }

      if (step == 0) {
        window.history.go(-1);
        return;
      }
      if (this.checkinType == "") {
        this.warningToast("Select some Option");
        return;
      }

      //forExpress
      if (this.checkinType == "expresscheckin") {
        if (step == 1) {
          this.currentStep = 1;
          return;
        }
        if (step === 3) {
          if (this.currentSelectedTypeId < 0) {
            this.warningToast("Enter Visit Type");
            return;
          } else if (this.currentStep == 2) {
            this.currentStep = 3;
            return;
          } else {
            this.currentStep = 100;
            return;
          }
        }
        if (step == 4) {
          if (this.currentSelectedReasonId < 0) {
            this.warningToast("Enter Visit Reason");
            return;
          } else if (this.currentStep == 3) {
            this.currentStep = 100;
            return;
          } else {
            this.currentStep = 4;
            return;
          }
        }
        if (step === 5) {
          if (this.basicDetails.firstName.length < 1) {
            this.warningToast("First Name is require");
            return;
          }
          if (this.basicDetails.lastName.length < 1) {
            this.warningToast("Last Name is require");
            return;
          }
          if (this.basicDetails.dob.length < 1) {
            this.warningToast("Date of birth is required");
            return;
          }
          if (this.basicDetails.gender == "") {
            this.warningToast("Choose a Gender");
            return;
          }
          // if (this.basicDetails.ssn.length < 1) {
          //   this.warningToast("Security Number is require");
          //   return;
          // }
          // if (this.basicDetails.ssn.length < 11) {
          //   this.warningToast("Security number of must be 9 length");
          //   return;
          // }
          if (!this.isValidateDate(this.basicDetails.dob)) {
            this.warningToast("Valid Date of Birth required");
            event.preventDefault();
            return;
          }
        }
        if (step === 6) {
          if (this.currentStep == 7 && this.setValue == 1) {
            return (this.currentStep = 100);
          }
          if (this.basicDetails.phone.length < 1) {
            this.warningToast("Phone Number is require");
            return;
          }
          if (this.basicDetails.phone.length < 12) {
            this.warningToast("Phone Number must be of 10 length");
            return;
          }
          if (this.basicDetails.email.length < 1) {
            this.warningToast("Email is require");
            return;
          }
          if (this.basicDetails.email.length > 0) {
            if (this.basicDetails.email != null) {
              if (!this.validEmail(this.basicDetails.email)) {
                this.Validity(this.e);
              }
            }
          }
        }
        if (step == 7) {
          window.scrollTo(0, 0);
          for (var n = 0; n < this.reasonDemos.length; n++) {
            if (this.reasonDemos[n].demo.questTypeName == "Date") {
              this.reasonDemos[n].demo.answer = moment(
                String(this.reasonDemos[n].demo.answer)
              ).format("YYYY-MM-DD");
            }
          }
          if (this.currentStep == 8) {
            this.currentStep = step;
          } else {
            if (this.basicDetails.address.length < 1) {
              this.warningToast("Street is require");
              return;
            }
            if (this.basicDetails.city.length < 1) {
              this.warningToast("City is require");
              return;
            }
            if (this.basicDetails.zip.length < 1) {
              this.warningToast("Zip is require");
              return;
            }
            if (this.basicDetails.state == "") {
              this.warningToast("State is require");
              return;
            }
            if (this.reasonDemos.length == 0 && this.reasonQuests.length == 0) {
              this.currentStep = 10;
              return;
            }
          }
        }
        //Custom
        if (step == 8) {
          window.scrollTo(0, 0);
          for (var k = 0; k < this.reasonDemos.length; k++) {
            if (this.reasonDemos[k].demo.answer == "") {
              if (this.reasonDemos[k].demo.isRequired == true) {
                this.warningToast("All Custom Demo input is require");
                return;
              }
            }
            if (this.reasonDemos[k].demo.questTypeName == "Phone Number") {
              if (this.reasonDemos[k].demo.answer.length < 12) {
                if (this.reasonDemos[k].demo.isRequired == true) {
                  this.warningToast("Phone must be of 10 length");
                  return;
                }
              }
            }
            if (
              this.reasonDemos[k].demo.questTypeName == "Date" &&
              this.reasonDemos[k].demo.isRequired == true
            ) {
              if (this.reasonDemos[k].demo.answer == "") {
                this.warningToast("Date is require");
                event.preventDefault();
                return;
              }
            }
            if (this.reasonDemos[k].demo.questTypeName == "Date") {
              if (this.reasonDemos[k].demo.isRequired == true) {
                if (!this.isValidateDate_1(this.reasonDemos[k].demo.answer)) {
                  this.warningToast("Valid Date is required");
                  event.preventDefault();
                  return;
                }
              } else if (this.reasonDemos[k].demo.answer != "Invalid date") {
                if (!this.isValidateDate_1(this.reasonDemos[k].demo.answer)) {
                  this.warningToast("Valid Date is required");
                  event.preventDefault();
                  return;
                }
              }
              this.reasonDemos[k].demo.answer = moment(
                String(this.reasonDemos[k].demo.answer)
              ).format("MM-DD-YYYY");
            }
            if (this.reasonDemos[k].demo.questTypeName == "Date") {
              if (!this.isValidateDate_1(this.reasonDemos[k].demo.answer)) {
                this.warningToast("Valid Date is required");
                event.preventDefault();
                return;
              }
              this.reasonDemos[k].demo.answer = moment(
                String(this.reasonDemos[k].demo.answer)
              ).format("MM-DD-YYYY");
            }
            if (this.reasonDemos[k].demo.questTypeName == "Email") {
              if (this.reasonDemos[k].demo.answer != null) {
                if (!this.validEmail(this.reasonDemos[k].demo.answer)) {
                  this.Validity(this.e);
                }
              }
            }
          }
        }
        //Question
        if (step == 9) {
          window.scrollTo(0, 0);
          for (var l = 0; l < this.reasonQuests.length; l++) {
            if (this.reasonQuests[l].demo.answer == "") {
              if (this.reasonQuests[l].demo.isRequired == true) {
                this.warningToast("All Questionere input is require");
                return;
              }
            }
            if (this.reasonQuests[l].demo.questTypeName == "Phone") {
              if (this.reasonQuests[l].demo.answer.length < 12) {
                if (this.reasonQuests[l].demo.isRequired == true) {
                  this.warningToast("Phone must be of 10 length");
                  return;
                }
              }
            }
            if (
              this.reasonQuests[j].demo.questTypeName == "Date" &&
              this.reasonQuests[j].demo.isRequired == true
            ) {
              if (this.reasonQuests[j].demo.answer == "") {
                this.warningToast("Date is require");
                event.preventDefault();
                return;
              }
            }
            if (this.reasonQuests[j].demo.questTypeName == "Date") {
              if (this.reasonQuests[j].demo.isRequired == true) {
                if (!this.isValidateDate_1(this.reasonQuests[j].demo.answer)) {
                  this.warningToast("Valid Date is required");
                  event.preventDefault();
                  return;
                }
              } else if (this.reasonQuests[j].demo.answer != "") {
                if (!this.isValidateDate_1(this.reasonQuests[j].demo.answer)) {
                  this.warningToast("Valid Date is required");
                  event.preventDefault();
                  return;
                }
              }
              this.reasonQuests[j].demo.answer = moment(
                String(this.reasonQuests[j].demo.answer)
              ).format("MM-DD-YYYY");
            }
            if (this.reasonQuests[l].demo.questTypeName == "Date") {
              if (!this.isValidateDate_1(this.reasonQuests[l].demo.answer)) {
                this.warningToast("Valid Date is required");
                event.preventDefault();
                return;
              }
              this.reasonQuests[l].demo.answer = moment(
                String(this.reasonQuests[l].demo.answer)
              ).format("MM-DD-YYYY");
            }
            if (this.reasonQuests[l].demo.questTypeName == "Email") {
              if (this.reasonQuests[l].demo.answer != null) {
                if (!this.validEmail(this.reasonQuests[l].demo.answer)) {
                  this.Validity(this.e);
                }
              }
            }
          }
        }
        this.newValDOB = moment(String(this.basicDetails.dob)).format(
          "MM-DD-YYYY"
        );
        this.currentStep = step;
      }

      //forCheckIn
      if (this.checkinType == "checkin") {
        if (step == 1 && this.checkinType == "checkin") {
          this.currentStep = 1;
          return;
        }
        if (step === 3 && this.currentSelectedTypeId < 0) {
          this.warningToast("Enter Visit Type");
          return;
        }
        //Visit
        if (step === 4 && this.currentSelectedReasonId < 0) {
          this.warningToast("Enter Visit Reason");
          return;
        }

        //Basic
        if (step === 5) {
          this.basicDetails.dob = this.getDOB();
          for (let r = 0; r < this.choseBasic.length; r++) {
            if (this.choseBasic[r].question == "Phone") {
              this.phoneVal = "Phone";
              if (this.choseBasic[r].isRequired == 1) {
                this.phoneRq = 1;
              }
            } else if (this.choseBasic[r].question == "Email") {
              this.emailVal = "Email";
              if (this.choseBasic[r].isRequired == 1) {
                this.emailRq = 1;
              }
            } else if (this.choseBasic[r].question == "SSN") {
              this.ssnVal = "SSN";
              if (this.choseBasic[r].isRequired == 1) {
                this.ssnRequire = 1;
              }
            }
          }
          if (this.basicDetails.firstName.length < 1) {
            this.warningToast("First Name is require");
            return;
          }
          if (this.basicDetails.lastName.length < 1) {
            this.warningToast("Last Name is require");
            return;
          }
          if (this.basicDetails.dob.length < 1) {
            this.warningToast("Date of birth is require");
            return;
          }
          if (this.basicDetails.gender == "") {
            this.warningToast("Choose a Gender");
            return;
          }
          if (this.ssnVal != "" && this.ssnRequire == 1) {
            if (this.basicDetails.ssn.length < 1) {
              this.warningToast("Security Number is require");
              return;
            }
            if (
              this.basicDetails.ssn != "" &&
              this.basicDetails.ssn.length < 11
            ) {
              this.warningToast("Security number of must be 9 length");
              return;
            }
          }
          if (!this.isValidateDate(this.basicDetails.dob)) {
            this.warningToast("Valid Date of Birth required");
            event.preventDefault();
            return;
          }
          //set DOB, SSN value
          this.valueSSN = this.choseBasic.filter((i) => i.question == "SSN");
          if (this.valueSSN.length == 1) {
            this.valueSSN = "SSN";
          } else {
            this.valueSSN = "";
          }

          this.newValDOB = "";
          this.newValDOB = moment(String(this.basicDetails.dob)).format(
            "MM-DD-YYYY"
          );

          let found = false;
          for (let c = 0; c < this.contactInfo.length; c++) {
            for (let b = 0; b < this.choseBasic.length; b++) {
              if (
                this.contactInfo[c] == this.choseBasic[b].question.toLowerCase()
              ) {
                found = true;
                break;
              }
            }
          }
          if (found == false) {
            if (this.isAddressFound() == true) {
              this.currentStep = 7;
              return;
            } else {
              if (this.isInsuranceFound() == true) {
                this.currentStep = 8;
                return;
              } else {
                if (this.noDemo == 1) {
                  this.currentStep = 9;
                  return;
                } else {
                  if (this.reasonQuests.length == 0) {
                    this.currentStep = 11;
                    return;
                  } else {
                    this.currentStep = 10;
                    return;
                  }
                }
              }
            }
          }

          this.currentStep = 6;
          return;
        }

        //Contact
        if (step === 6) {
          for (let p = 0; p < this.choseBasic.length; p++) {
            if (this.choseBasic[p].question == "Street") {
              this.addVal = "Street";
              if (this.choseBasic[p].isRequired == 1) {
                this.streetRq = 1;
              }
            } else if (this.choseBasic[p].question == "City") {
              this.cityVal = "City";
              if (this.choseBasic[p].isRequired == 1) {
                this.cityRq = 1;
              }
            } else if (this.choseBasic[p].question == "State") {
              this.stateVal = "State";
              if (this.choseBasic[p].isRequired == 1) {
                this.stateRq = 1;
              }
            } else if (this.choseBasic[p].question == "Zip") {
              this.zipVal = "Zip";
              if (this.choseBasic[p].isRequired == 1) {
                this.zipRq = 1;
              }
            }
          }
          if (this.phoneVal != "" && this.phoneRq == 1) {
            if (this.basicDetails.phone.length < 1) {
              this.warningToast("Phone Number is require");
              return;
            }
          }
          if (
            this.basicDetails.phone != "" &&
            this.basicDetails.phone.length < 12
          ) {
            this.warningToast("Phone Number must be of 10 length");
            return;
          }

          if (this.emailVal != "" && this.emailRq == 1) {
            if (this.basicDetails.email.length < 1) {
              this.warningToast("Email is require");
              return;
            }
          }
          if (this.basicDetails.email.length > 0) {
            if (this.basicDetails.email != null) {
              if (!this.validEmail(this.basicDetails.email)) {
                this.Validity(this.e);
              }
            }
          }

          if (this.isAddressFound() == true) {
            this.currentStep = 7;
            return;
          } else {
            if (this.isInsuranceFound() == true) {
              this.currentStep = 8;
              return;
            } else {
              if (this.noDemo == 1) {
                this.currentStep = 9;
                return;
              } else {
                if (this.reasonQuests.length == 0) {
                  this.currentStep = 11;
                  return;
                } else if (this.reasonQuests.length != 0) {
                  this.currentStep = 10;
                  return;
                }
              }
            }
          }
        }

        //Address
        if (step === 7) {
          for (let n = 0; n < this.choseBasic.length; n++) {
            if (this.choseBasic[n].question == "Primary Insurance Name") {
              this.primaryInsuranceName = "Primary Insurance Name";
              if (this.choseBasic[n].isRequired == 1) {
                this.primaryInsNRq = 1;
              }
            } else if (
              this.choseBasic[n].question == "Primary Insurance Number"
            ) {
              this.primaryInsuranceNumber = "Primary Insurance Number";
              if (this.choseBasic[n].isRequired == 1) {
                this.primaryInsNumRq = 1;
              }
            } else if (
              this.choseBasic[n].question == "Primary Insurance Image Upload"
            ) {
              this.primaryInsuranceId = "Primary Insurance Id";
              if (this.choseBasic[n].isRequired == 1) {
                this.primaryInsImage = 1;
              }
            } else if (
              this.choseBasic[n].question == "Primary Insurance Group Name"
            ) {
              this.primaryInsuranceGroup = "Primary Insurance Group";
              if (this.choseBasic[n].isRequired == 1) {
                this.primaryInsGrpRq = 1;
              }
            } else if (
              this.choseBasic[n].question == "Secondary Insurance Name"
            ) {
              this.secondaryInsuranceName = "Secondary Insurance Name";
              if (this.choseBasic[n].isRequired == 1) {
                this.secondaryInsNRq = 1;
              }
            } else if (
              this.choseBasic[n].question == "Secondary Insurance Number"
            ) {
              this.secondaryInsuranceNumber = "Secondary Insurance Number";
              if (this.choseBasic[n].isRequired == 1) {
                this.secondaryInsNumRq = 1;
              }
            } else if (
              this.choseBasic[n].question == "Secondary Insurance Group Name"
            ) {
              this.secondaryInsuranceGroup = "Secondary Insurance Group";
              if (this.choseBasic[n].isRequired == 1) {
                this.secondaryInsGrpRq = 1;
              }
            } else if (
              this.choseBasic[n].question == "Secondary Insurance Image upload"
            ) {
              this.secondaryInsuranceId = "Secondary Insurance Id";
              if (this.choseBasic[n].isRequired == 1) {
                this.secondaryInsImage = 1;
              }
            }
          }

          this.selectDemo = [];
          window.scrollTo(0, 0);
          for (var m = 0; m < this.reasonDemos.length; m++) {
            if (this.reasonDemos[m].demo.questTypeName == "Date") {
              this.reasonDemos[m].demo.answer = moment(
                String(this.reasonDemos[m].demo.answer)
              ).format("YYYY-MM-DD");
            }
          }
          if (this.addVal != "" && this.streetRq == 1) {
            if (this.basicDetails.address.length < 1) {
              this.warningToast("Street is require");
              return;
            }
          }
          if (this.cityVal != "" && this.cityRq == 1) {
            if (this.basicDetails.city.length < 1) {
              this.warningToast("City is require");
              return;
            }
          }
          if (this.zipVal != "" && this.zipRq == 1) {
            if (this.basicDetails.zip.length < 1) {
              this.warningToast("Zip is require");
              return;
            }
          }
          if (this.stateVal != "" && this.stateRq == 1) {
            if (this.basicDetails.state == "") {
              this.warningToast("State is require");
              return;
            }
          }

          if (this.isInsuranceFound() == true) {
            this.currentStep = 8;
            return;
          } else {
            if (this.noDemo == 1) {
              this.currentStep = 9;
              return;
            } else {
              if (this.reasonQuests.length == 0) {
                this.currentStep = 11;
                return;
              } else if (this.reasonQuests.length != 0) {
                this.currentStep = 10;
                return;
              }
            }
          }
        }

        //Insurance
        if (step == 8) {
          window.scrollTo(0, 0);
          if (this.primaryInsuranceName != "" && this.primaryInsNRq == 1) {
            if (this.Insurance.primaryInsuranceName.length < 1) {
              this.warningToast("Primary Insurance Name is require");
              return;
            }
          }
          if (this.primaryInsuranceNumber != "" && this.primaryInsNumRq == 1) {
            if (this.Insurance.primaryInsuranceNumber.length < 1) {
              this.warningToast("Primary Insurance Number is require");
              return;
            }
          }
          if (this.primaryInsuranceGroup != "" && this.primaryInsGrpRq == 1) {
            if (this.Insurance.primaryInsuranceGroup.length < 1) {
              this.warningToast("Primary Insurance Group is require");
              return;
            }
          }
          if (this.primaryInsImage == 1) {
            if (typeof this.SingleImage.Image === "undefined") {
              this.warningToast("Primary Insurance Image is require");
              return;
            }
          }
          if (this.secondaryInsuranceName != "" && this.secondaryInsNRq == 1) {
            if (this.Insurance.secondaryInsuranceName.length < 1) {
              this.warningToast("Secondary Insurance Name is require");
              return;
            }
          }
          if (
            this.secondaryInsuranceNumber != "" &&
            this.secondaryInsNumRq == 1
          ) {
            if (this.Insurance.secondaryInsuranceNumber.length < 1) {
              this.warningToast("Secondary Insurance Number is require");
              return;
            }
          }
          if (
            this.secondaryInsuranceGroup != "" &&
            this.secondaryInsGrpRq == 1
          ) {
            if (this.Insurance.secondaryInsuranceGroup.length < 1) {
              this.warningToast("Secondary Insurance Group is require");
              return;
            }
          }
          if (this.secondaryInsImage == 1) {
            if (typeof this.SingleImage1.Image1 === "undefined") {
              this.warningToast("Secondary Insurance Image is require");
              return;
            }
          }

          if (this.noDemo == 1) {
            this.currentStep = 9;
            return;
          } else {
            if (this.reasonQuests.length == 0) {
              this.currentStep = 11;
              return;
            } else if (this.reasonQuests.length != 0) {
              this.currentStep = 10;
              return;
            }
          }
        }

        //Custom
        if (step == 9) {
          window.scrollTo(0, 0);
          for (var i = 0; i < this.reasonDemos.length; i++) {
            if (this.reasonDemos[i].demo.answer == "") {
              if (this.reasonDemos[i].demo.isRequired == true) {
                this.warningToast("All Custom Demo input is require");
                return;
              }
            }
            if (this.reasonDemos[i].demo.questTypeName == "Phone Number") {
              if (this.reasonDemos[i].demo.answer.length < 12) {
                if (this.reasonDemos[i].demo.isRequired == true) {
                  this.warningToast("Phone must be of 10 length");
                  return;
                }
              }
            }
            if (
              this.reasonDemos[i].demo.questTypeName == "Date" &&
              this.reasonDemos[i].demo.isRequired == true
            ) {
              if (this.reasonDemos[i].demo.answer == "") {
                this.warningToast("Date is require");
                event.preventDefault();
                return;
              }
            }
            if (this.reasonDemos[i].demo.questTypeName == "Date") {
              if (this.reasonDemos[i].demo.isRequired == true) {
                if (!this.isValidateDate_1(this.reasonDemos[i].demo.answer)) {
                  this.warningToast("Valid Date is required");
                  event.preventDefault();
                  return;
                }
              } else if (this.reasonDemos[i].demo.answer != "") {
                if (!this.isValidateDate_1(this.reasonDemos[i].demo.answer)) {
                  this.warningToast("Valid Date is required");
                  event.preventDefault();
                  return;
                }
              }
              this.reasonDemos[i].demo.answer = moment(
                String(this.reasonDemos[i].demo.answer)
              ).format("MM-DD-YYYY");
            }
            if (this.reasonDemos[i].demo.questTypeName == "Email") {
              if (this.reasonDemos[i].demo.answer != null) {
                if (!this.validEmail(this.reasonDemos[i].demo.answer)) {
                  this.Validity(this.e);
                }
              }
            }
          }

          if (this.reasonQuests.length == 0) {
            this.currentStep = 11;
            return;
          } else if (this.reasonQuests.length != 0) {
            this.currentStep = 10;
            return;
          }
        }

        //Question
        if (step == 10) {
          window.scrollTo(0, 0);
          for (var j = 0; j < this.reasonQuests.length; j++) {
            if (this.reasonQuests[j].demo.answer == "") {
              if (this.reasonQuests[j].demo.isRequired == true) {
                this.warningToast("All Questionere input is require");
                return;
              }
            }
            if (this.reasonQuests[j].demo.questTypeName == "Phone") {
              if (this.reasonQuests[j].demo.answer.length < 12) {
                if (this.reasonQuests[j].demo.isRequired == true) {
                  this.warningToast("Phone must be of 10 length");
                  return;
                }
              }
            }
            if (
              this.reasonQuests[j].demo.questTypeName == "Date" &&
              this.reasonQuests[j].demo.isRequired == true
            ) {
              if (this.reasonQuests[j].demo.answer == "") {
                this.warningToast("Date is require");
                event.preventDefault();
                return;
              }
            }
            if (this.reasonQuests[j].demo.questTypeName == "Date") {
              if (this.reasonQuests[j].demo.isRequired == true) {
                if (!this.isValidateDate_1(this.reasonQuests[j].demo.answer)) {
                  this.warningToast("Valid Date is required");
                  event.preventDefault();
                  return;
                }
              } else if (this.reasonQuests[j].demo.answer != "") {
                if (!this.isValidateDate_1(this.reasonQuests[j].demo.answer)) {
                  this.warningToast("Valid Date is required");
                  event.preventDefault();
                  return;
                }
              }
              this.reasonQuests[j].demo.answer = moment(
                String(this.reasonQuests[j].demo.answer)
              ).format("MM-DD-YYYY");
            }
            if (this.reasonQuests[j].demo.questTypeName == "Email") {
              if (this.reasonQuests[j].demo.answer != null) {
                if (!this.validEmail(this.reasonQuests[j].demo.answer)) {
                  this.Validity(this.e);
                }
              }
            }
          }
          this.currentStep = "";
          this.currentStep = 11;
          return;
        }

        this.alertShown = 0;
        this.currentStep = step;
      }
    },
    onSubmit() {
      console.log("Submit");
    },
    loadInit() {
      this.intDummyComm();
      this.dummyComm.prId = localStorage.xeon;
      //this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Checkin/GtBscDta";
      this.axiosGetData(url, this.dummyComm, 1);
    }, // load Init
    //-------------------- Common Methods
    async axiosGetData(myUrl, myData, what) {
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
      })
        .then((res) => {
          if (what === 1) {
            this.patientsIdsLst = res.data.patLst;
            this.types = res.data.visits;
            this.demos_1 = res.data.demos_1;
            this.reasons = res.data.reasons;
            this.actualDemos = res.data.actualDemos;
            this.actualQuestions = res.data.actualQuestions;
            this.questionOptions = res.data.questionOptions;
            this.visitTypeQuestDemo = res.data.visitTypeQuestDemo;
          } else if (what === 2) {
            this.groupId = res.data.groupId;
            this.groupColor = res.data.groupColor;
            this.patientList = res.data.groupedPatients;

            this.loader.hide();
            this.successToast();
            this.currentStep = 12;
            // location.reload();
          } else if (what === 11) {
            this.locationName = res.data.data.name;
          }
        })
        .catch(function(error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => {
          //this.datePicker();
          //this.calcTimerRoutine();
        });
    }, // axiosGetData

    addMorePatients() {
      this.newValDOB = "";
      this.day = null;
      this.month = null;
      this.year = null;
      this.basicDetails = {
        pndx: 0,
        patientId: 0,
        firstName: "",
        lastName: "",
        currentdate: new Date(),
        dos: "",
        dob: "",
        gender: "",
        ssn: "",
        phone: "",
        email: "",
        address: "",
        city: "",
        zip: "",
        state: "",
      };
      this.Insurance = {
        primaryInsuranceName: "",
        primaryInsuranceNumber: "",
        primaryInsuranceGroup: "",
        primaryInsuranceId: "",
        secondaryInsuranceName: "",
        secondaryInsuranceNumber: "",
        secondaryInsuranceGroup: "",
        secondaryInsuranceId: "",
      };
      this.checkinType = "";
      this.activeType = "";
      this.activeType = "";
      this.activeReason = "";
      this.visitTypeReasons = "";
      this.currentSelectedTypeId = -1;
      this.currentSelectedReasonId = -1;
      this.reasonQuests = [];
      this.reasonDemos = [];
      this.activeDemo = {
        reasonId: 0,
        visitDetailId: 0,
        demo: {
          questId: 0,
          srNo: 0,
          questName: "",
          question: "",
          answer: "",
          questionInputTypeId: 0,
          questTypeName: "",
          demoOptions: {
            srNo: 0,
            questOption: "",
          },
        },
      };
      this.currentStep = 1;
    },

    cancelAddingMorePatients() {
      this.groupId = "";
      this.groupColor = "";
      location.reload();
    },

    myHoverfunc() {
      if (this.checkinType == "checkin") {
        return "btn btn-success waves-effect";
      } else return "btn btn-outline-success waves-effect";
    },
    myHoverfunc1() {
      if (this.checkinType == "expresscheckin") {
        return "btn btn-success waves-effect";
      } else return "btn btn-outline-success waves-effect";
    },

    async isMonth(evt, val) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode == 46) {
        evt.preventDefault();
      } else {
        //Beautiful
        val = val + String.fromCharCode(evt.keyCode);
        if (parseInt(val) > 12) {
          evt.preventDefault();
          return;
        }
        return true;
      }
    },
    isDay(evt, val) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode == 46) {
        evt.preventDefault();
      } else {
        //Beautiful
        val = val + String.fromCharCode(evt.keyCode);

        if (parseInt(val) > 31) {
          evt.preventDefault();
          return;
        }
        return true;
      }
    },
    isYear(evt, val) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode == 46) {
        evt.preventDefault();
      } else {
        //Beautiful
        val = val + String.fromCharCode(evt.keyCode);
        if (parseInt(val) > 3000) {
          evt.preventDefault();
          return;
        }
        return true;
      }
    },
    getDOB() {
      this.day = ("0" + this.day).slice(-2);
      this.month = ("0" + this.month).slice(-2);
      const d = "" + this.year + "-" + this.month + "-" + this.day;
      return d;
    },
    GetPracticeNameAddess() {
      const url = this.SERVER + "/VNSPRAAPI/Practices/GetPractice_1";
      const myData = {
        OwnerId: this.dummyComm.Extras1,
        PracticeId: localStorage.xeon,
      };
      this.axiosGetData(url, myData, 11);
    },
  }, // methods
  mounted() {
    //window.$('.dropify').dropify();
    this.intDummyComm();
    this.GetPracticeNameAddess();
    this.img = this.$refs.myimage;
    this.img1 = this.$refs.myimage1;
    this.loadInit();
  }, // mounted
  beforeUnmount() {
    localStorage.patientsIdsLst = this.patientsIdsLst.toString();
    localStorage.veinsId = "";
  },
  watch: {
    day: function() {
      if (parseInt(this.day) > 31) {
        this.day = "31";
      }
      if (this.day !== null && this.day.length > 1) {
        document.getElementById("doby").focus();
      }
    },
    month: function() {
      if (parseInt(this.month) > 12) {
        this.month = "12";
      }
      if (this.month !== null && this.month.length > 1) {
        document.getElementById("dobd").focus();
      }
    },
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
#asterik {
  color: red;
  font-size: 8px;
}
img {
  display: block;
  /* This rule is very important, please don't ignore this */
  max-width: 100%;
}
.cropper {
  height: 600px;
  background: #ddd;
}
#butt1 {
  margin-left: -58px;
  position: absolute;
  margin-top: 2px;
}
#butt2 {
  margin-left: 0px;
  position: relative;
  margin-top: 2px;
}
#butt3 {
  margin-left: -58px;
  position: absolute;
  margin-top: 2px;
}
#butt4 {
  margin-left: 0px;
  position: relative;
  margin-top: 2px;
}
.month {
  width: 40px;
  margin-bottom: 10px;
  margin-left: -0.2%;
  border: none;
}
.day {
  width: 40px;
  margin-bottom: 10px;
  border: none;
}
.year {
  width: 45px;
  margin-bottom: 10px;
  border: none;
}

.datedivider {
  margin-top: 1.7px;
}

.set-button {
  display: block;
  width: 104%;
  border: 2px solid #ff7062;
  background: #ff7062;
  border-radius: 12px;
  text-align: center;
  padding: 10px 2em;
  font-size: 1.2rem;
  font-weight: bold;
  box-shadow: 0 0 1px 1px rgb(0 0 0 / 20%);
}
.set-button-warning {
  display: block;
  width: 104%;
  border: 2px solid #ff7062;
  background: white;
  border-radius: 12px;
  text-align: center;
  padding: 10px 2em;
  font-size: 1.2rem;
  font-weight: bold;
  box-shadow: 0 0 1px 1px rgb(0 0 0 / 20%);
}

.patientListSize {
  max-height: 350px !important;
  overflow-y: scroll !important;
}
</style>
